
/* eslint-disable */

import { Helper } from '../common/helpers/Helper';

export const venueFillRate = {
  items: [
    {
      venueCode: 'DD-HB4S4G',
      state: 'SERVED',
      deviceIdState: '1750308118959SERVED',
      dp: 'PO',
      durationsecs: 30,
      url: 'https://static.placeexchange.com/8213bb33-c0fe-43db-b408-285022eadf4d/563149/072d5235-816b-4a82-b4e2-0823b72273b6.mp4',
      popStatus: 'SUCCESS',
      id: '1750308118959-PO1782799172399',
      brCalc: '',
      mimetype: 'video/mp4',
      adDropReason: '',
      popTs: '06/30/2026 12:59:32 AM CDT',
      createdTs: '06/30/2026 12:59:32 AM CDT'
    },
    {
      venueCode: 'DD-HB4S4G',
      state: 'SERVED',
      deviceIdState: '1750308118959SERVED',
      dp: 'PO',
      durationsecs: 15,
      url: 'https://static.placeexchange.com/mc/8213bb33-c0fe-43db-b408-285022eadf4d/20260605/9062847194434848229.mp4',
      popStatus: 'SUCCESS',
      id: '1750308118959-PO1782798843264',
      brCalc: '',
      mimetype: 'video/mp4',
      adDropReason: '',
      popTs: '06/30/2026 12:54:03 AM CDT',
      createdTs: '06/30/2026 12:54:03 AM CDT'
    },
    {
      venueCode: 'DD-HB4S4G',
      state: 'SERVED',
      deviceIdState: '1750308118959SERVED',
      dp: 'PO',
      durationsecs: 30,
      url: 'https://static.placeexchange.com/8213bb33-c0fe-43db-b408-285022eadf4d/563149/072d5235-816b-4a82-b4e2-0823b72273b6.mp4',
      popStatus: 'SUCCESS',
      id: '1750308118959-PO1782798690886',
      brCalc: '',
      mimetype: 'video/mp4',
      adDropReason: '',
      popTs: '06/30/2026 12:51:30 AM CDT',
      createdTs: '06/30/2026 12:51:30 AM CDT'
    },
    {
      venueCode: 'DD-HB4S4G',
      state: 'SERVED',
      deviceIdState: '1750308118959SERVED',
      dp: 'PO',
      durationsecs: 30,
      url: 'https://static.placeexchange.com/mc/8213bb33-c0fe-43db-b408-285022eadf4d/20260609/3768936995401788421.mp4',
      popStatus: 'SUCCESS',
      id: '1750308118959-PO1782798214133',
      brCalc: '',
      mimetype: 'video/mp4',
      adDropReason: '',
      popTs: '06/30/2026 12:43:34 AM CDT',
      createdTs: '06/30/2026 12:43:34 AM CDT'
    },
    {
      venueCode: 'DD-HB4S4G',
      state: 'SERVED',
      deviceIdState: '1750308118959SERVED',
      dp: 'PO',
      durationsecs: 30,
      url: 'https://static.placeexchange.com/mc/8213bb33-c0fe-43db-b408-285022eadf4d/20260609/13537081289552208896.mp4',
      popStatus: 'SUCCESS',
      id: '1750308118959-PO1782798196432',
      brCalc: '',
      mimetype: 'video/mp4',
      adDropReason: '',
      popTs: '06/30/2026 12:43:16 AM CDT',
      createdTs: '06/30/2026 12:43:16 AM CDT'
    },
    {
      venueCode: 'DD-HB4S4G',
      state: 'SERVED',
      deviceIdState: '1750308118959SERVED',
      dp: 'PO',
      durationsecs: 30,
      url: 'https://static.placeexchange.com/8213bb33-c0fe-43db-b408-285022eadf4d/aarki-82/15859e50-62ed-4112-8db7-f722f59ca1f6.mp4',
      popStatus: 'SUCCESS',
      id: '1750308118959-PO1782798081659',
      brCalc: '',
      mimetype: 'video/mp4',
      adDropReason: '',
      popTs: '06/30/2026 12:41:21 AM CDT',
      createdTs: '06/30/2026 12:41:21 AM CDT'
    },
    {
      venueCode: 'DD-HB4S4G',
      state: 'SERVED',
      deviceIdState: '1750308118959SERVED',
      dp: 'PO',
      durationsecs: 30,
      url: 'https://static.placeexchange.com/8213bb33-c0fe-43db-b408-285022eadf4d/b5ba19c1d78278696082695d72ea33fa/d36e5fc8-07db-49f4-a0a0-b9968bcca983.mp4',
      popStatus: 'SUCCESS',
      id: '1750308118959-PO1782797714260',
      brCalc: '',
      mimetype: 'video/mp4',
      adDropReason: '',
      popTs: '06/30/2026 12:35:14 AM CDT',
      createdTs: '06/30/2026 12:35:14 AM CDT'
    },
    {
      venueCode: 'DD-HB4S4G',
      state: 'SERVED',
      deviceIdState: '1750308118959SERVED',
      dp: 'PO',
      durationsecs: 30,
      url: 'https://static.placeexchange.com/8213bb33-c0fe-43db-b408-285022eadf4d/563149/072d5235-816b-4a82-b4e2-0823b72273b6.mp4',
      popStatus: 'SUCCESS',
      id: '1750308118959-PO1782797684785',
      brCalc: '',
      mimetype: 'video/mp4',
      adDropReason: '',
      popTs: '06/30/2026 12:34:44 AM CDT',
      createdTs: '06/30/2026 12:34:44 AM CDT'
    }
  ],
  count: 8,
  dpSummary: {
    PU: { played: 0, totalDuration: 0 },
    PO: { played: 18, totalDuration: 456 },
    VS: { played: 0, totalDuration: 0 },
    IN: { played: 0, totalDuration: 0 },
    AD: { played: 0, totalDuration: 0 },
    BO: { played: 0, totalDuration: 0 },
    DD: { played: 0, totalDuration: 0 },
    CMS: { played: 206, totalDuration: 2702.945606 },
    FR: { played: 0, totalDuration: 0 },
    HI: { played: 0, totalDuration: 0 },
    LO: { played: 0, totalDuration: 0 },
    PX: { played: 0, totalDuration: 0 },
    VC: { played: 6, totalDuration: 0 },
    VI: { played: 0, totalDuration: 0 },
    AK: { played: 0, totalDuration: 0 },
    VH: { played: 0, totalDuration: 0 }
  },
  missingVenues: [],
  _apiversion: '1.0.52'
}

export const deviceActivity = {
  "items": [
    {
      "ads_AD": 22,
      "ads_DD": 41,
      "ads_HI": 5,
      "ads_PX": 3,
      "ads_VC": 135,
      "ads_VI": 237,
      "cmsPop": 6784,
      "createdTs": 1769320929192,
      "createdYm": "202601",
      "deviceId": "1663612104941",
      "err_AD": 97,
      "err_BO": 28,
      "err_DD": 37,
      "err_FR": 65,
      "err_HI": 29,
      "err_PX": 18,
      "err_VC": 7,
      "err_VI": 222,
      "get_AD": 8687,
      "get_BO": 17346,
      "get_DD": 1342,
      "get_FR": 8687,
      "get_HI": 17346,
      "get_PX": 17353,
      "get_VC": 142,
      "get_VI": 8689,
      "groupId": "1696974682907",
      "h00": 6,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 6,
      "h05": 6,
      "h06": 6,
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 6,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h19": 6,
      "h20": 6,
      "h21": 6,
      "h22": 6,
      "h23": 6,
      "hf": 1769320929176,
      "id": "1663612104941-20260125",
      "lastModifiedUserId": "APIKey",
      "latestErr_AD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_BO": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_DD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_FR": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_HI": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_PX": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VC": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VI": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "lsd_AD": 22,
      "lsd_DD": 33,
      "lsd_HI": 5,
      "lsd_PX": 3,
      "lsd_VC": 135,
      "lsd_VI": 237,
      "modifiedTs": 1769407312994,
      "modifiedYm": "202601",
      "pop_AD": 18,
      "pop_DD": 36,
      "pop_HI": 5,
      "pop_PX": 3,
      "pop_VC": 134,
      "pop_VI": 237,
      "period": "20260125",
      "statusByHour": [
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6
      ],
      "noOfhrsOnline": 24,
      "deviceCode": "DD-2F46FC",
      "deviceTitle": "Foodplus_Masterlane_2_DD_2F46FC",
      "info": {}
    },
    {
      "ads_AD": 18,
      "ads_DD": 104,
      "ads_HI": 6,
      "ads_PX": 6,
      "ads_VC": 141,
      "ads_VI": 228,
      "cmsPop": 6557,
      "createdTs": 1769407332703,
      "createdYm": "202601",
      "deviceId": "1663612104941",
      "err_AD": 26,
      "err_BO": 7,
      "err_DD": 13,
      "err_FR": 29,
      "err_HI": 7,
      "err_PX": 4,
      "err_VC": 1,
      "err_VI": 202,
      "get_AD": 8662,
      "get_BO": 17316,
      "get_DD": 1337,
      "get_FR": 8661,
      "get_HI": 17316,
      "get_PX": 17320,
      "get_VC": 142,
      "get_VI": 8661,
      "groupId": "1696974682907",
      "h00": 6,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 6,
      "h05": 6,
      "h06": 6,
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 6,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h19": 6,
      "h20": 6,
      "h21": 6,
      "h22": 6,
      "h23": 6,
      "hf": 1769407332683,
      "id": "1663612104941-20260126",
      "lastModifiedUserId": "APIKey",
      "latestErr_AD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_BO": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_DD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_FR": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_HI": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_PX": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VC": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "code": 429
      },
      "lsd_AD": 18,
      "lsd_DD": 75,
      "lsd_HI": 6,
      "lsd_PX": 6,
      "lsd_VC": 141,
      "lsd_VI": 228,
      "modifiedTs": 1769493719030,
      "modifiedYm": "202601",
      "pop_AD": 18,
      "pop_DD": 104,
      "pop_HI": 6,
      "pop_PX": 6,
      "pop_VC": 140,
      "pop_VI": 228,
      "period": "20260126",
      "statusByHour": [
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6
      ],
      "noOfhrsOnline": 24,
      "deviceCode": "DD-2F46FC",
      "deviceTitle": "Foodplus_Masterlane_2_DD_2F46FC",
      "info": {}
    },
    {
      "ads_AD": 15,
      "ads_BO": 1,
      "ads_DD": 134,
      "ads_HI": 6,
      "ads_PX": 8,
      "ads_VC": 134,
      "ads_VI": 193,
      "cmsPop": 7017,
      "createdTs": 1769493735930,
      "createdYm": "202601",
      "deviceId": "1663612104941",
      "err_AD": 634,
      "err_BO": 660,
      "err_DD": 157,
      "err_FR": 740,
      "err_HI": 731,
      "err_PX": 660,
      "err_VC": 14,
      "err_VI": 841,
      "get_AD": 9015,
      "get_BO": 17397,
      "get_DD": 1397,
      "get_FR": 9014,
      "get_HI": 17310,
      "get_PX": 17409,
      "get_VC": 148,
      "get_VI": 9015,
      "groupId": "1696974682907",
      "h00": 6,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 6,
      "h05": 6,
      "h06": 6,
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 6,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h19": 6,
      "h20": 6,
      "h21": 6,
      "h22": 6,
      "h23": 3,
      "hf": 1769493735908,
      "id": "1663612104941-20260127",
      "lastModifiedUserId": "APIKey",
      "latestErr_AD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_BO": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_DD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_FR": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_HI": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_PX": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VC": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VI": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "lsd_AD": 15,
      "lsd_BO": 1,
      "lsd_DD": 92,
      "lsd_HI": 6,
      "lsd_PX": 8,
      "lsd_VC": 134,
      "lsd_VI": 193,
      "modifiedTs": 1769580160564,
      "modifiedYm": "202601",
      "pop_AD": 15,
      "pop_BO": 1,
      "pop_DD": 133,
      "pop_HI": 6,
      "pop_PX": 8,
      "pop_VC": 134,
      "pop_VI": 193,
      "period": "20260127",
      "statusByHour": [
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        3
      ],
      "noOfhrsOnline": 24,
      "deviceCode": "DD-2F46FC",
      "deviceTitle": "Foodplus_Masterlane_2_DD_2F46FC",
      "info": {}
    },
    {
      "ads_AD": 13,
      "ads_DD": 150,
      "ads_HI": 3,
      "ads_PX": 6,
      "ads_VC": 126,
      "ads_VI": 198,
      "cmsPop": 7441,
      "createdTs": 1769580137121,
      "createdYm": "202601",
      "deviceId": "1663612104941",
      "err_AD": 712,
      "err_BO": 742,
      "err_DD": 231,
      "err_FR": 955,
      "err_HI": 655,
      "err_PX": 653,
      "err_VC": 27,
      "err_VI": 935,
      "get_AD": 9484,
      "get_BO": 18225,
      "get_DD": 1466,
      "get_FR": 9487,
      "get_HI": 18301,
      "get_PX": 18336,
      "get_VC": 153,
      "get_VI": 9482,
      "groupId": "1696974682907",
      "h00": 6,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 6,
      "h05": 6,
      "h06": 6,
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 6,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h19": 6,
      "h20": 6,
      "h21": 6,
      "h22": 6,
      "h23": 6,
      "hf": 1769580137106,
      "id": "1663612104941-20260128",
      "lastModifiedUserId": "APIKey",
      "latestErr_AD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_BO": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_DD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_FR": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_HI": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_PX": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VC": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "code": 429
      },
      "lsd_AD": 13,
      "lsd_DD": 116,
      "lsd_HI": 3,
      "lsd_PX": 6,
      "lsd_VC": 126,
      "lsd_VI": 198,
      "modifiedTs": 1769666519178,
      "modifiedYm": "202601",
      "pop_AD": 7,
      "pop_DD": 142,
      "pop_HI": 3,
      "pop_PX": 6,
      "pop_VC": 125,
      "pop_VI": 195,
      "period": "20260128",
      "statusByHour": [
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6
      ],
      "noOfhrsOnline": 24,
      "deviceCode": "DD-2F46FC",
      "deviceTitle": "Foodplus_Masterlane_2_DD_2F46FC",
      "info": {}
    },
    {
      "ads_AD": 164,
      "ads_DD": 184,
      "ads_HI": 3,
      "ads_VC": 138,
      "ads_VI": 211,
      "cmsPop": 5889,
      "createdTs": 1769666534573,
      "createdYm": "202601",
      "deviceId": "1663612104941",
      "err_AD": 142,
      "err_BO": 46,
      "err_DD": 75,
      "err_FR": 154,
      "err_HI": 47,
      "err_PX": 26,
      "err_VC": 5,
      "err_VI": 172,
      "get_AD": 8674,
      "get_BO": 17391,
      "get_DD": 1346,
      "get_FR": 8720,
      "get_HI": 17388,
      "get_PX": 17410,
      "get_VC": 143,
      "get_VI": 8718,
      "groupId": "1696974682907",
      "h00": 6,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 6,
      "h05": 6,
      "h06": 6,
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 6,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h19": 6,
      "h20": 6,
      "h21": 6,
      "h22": 6,
      "h23": 6,
      "hf": 1769666534554,
      "id": "1663612104941-20260129",
      "lastModifiedUserId": "APIKey",
      "latestErr_AD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_BO": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_DD": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_FR": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_HI": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_PX": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VC": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "latestErr_VI": {
        "body": {
          "message": "Aborted"
        },
        "code": {}
      },
      "lsd_AD": 164,
      "lsd_DD": 135,
      "lsd_HI": 3,
      "lsd_VC": 138,
      "lsd_VI": 211,
      "modifiedTs": 1769752916120,
      "modifiedYm": "202601",
      "pop_AD": 141,
      "pop_DD": 180,
      "pop_HI": 3,
      "pop_VC": 137,
      "pop_VI": 211,
      "period": "20260129",
      "statusByHour": [
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6
      ],
      "noOfhrsOnline": 24,
      "deviceCode": "DD-2F46FC",
      "deviceTitle": "Foodplus_Masterlane_2_DD_2F46FC",
      "info": {}
    }
  ],
  "stats": {
    "totalGet": 404436,
    "totalErr": 10806,
    "totalPop": 2575,
    "totalLsd": 2471,
    "totalCmsPop": 33688,
    "totalAdApiReqs": 0,
    "totalAds": 2633,
    "totalGet_AD": 44522,
    "totalErr_AD": 1611,
    "totalPop_AD": 199,
    "totalLsd_AD": 232,
    "totalAds_AD": 232,
    "totalGet_BO": 87675,
    "totalErr_BO": 1483,
    "totalPop_BO": 1,
    "totalLsd_BO": 1,
    "totalAds_BO": 1,
    "totalGet_DD": 6888,
    "totalErr_DD": 513,
    "totalPop_DD": 595,
    "totalLsd_DD": 451,
    "totalAds_DD": 613,
    "totalGet_CMS": 0,
    "totalErr_CMS": 0,
    "totalPop_CMS": 0,
    "totalLsd_CMS": 0,
    "totalAds_CMS": 0,
    "totalGet_FR": 44569,
    "totalErr_FR": 1943,
    "totalPop_FR": 0,
    "totalLsd_FR": 0,
    "totalAds_FR": 0,
    "totalGet_HI": 87661,
    "totalErr_HI": 1469,
    "totalPop_HI": 23,
    "totalLsd_HI": 23,
    "totalAds_HI": 23,
    "totalGet_LO": 0,
    "totalErr_LO": 0,
    "totalPop_LO": 0,
    "totalLsd_LO": 0,
    "totalAds_LO": 0,
    "totalGet_PX": 87828,
    "totalErr_PX": 1361,
    "totalPop_PX": 23,
    "totalLsd_PX": 23,
    "totalAds_PX": 23,
    "totalGet_VC": 728,
    "totalErr_VC": 54,
    "totalPop_VC": 670,
    "totalLsd_VC": 674,
    "totalAds_VC": 674,
    "totalGet_VI": 44565,
    "totalErr_VI": 2372,
    "totalPop_VI": 1064,
    "totalLsd_VI": 1067,
    "totalAds_VI": 1067
  },
  "_apiversion": "1.0.52"
}

export const adminDevicesActivity = {
  "items": [
    {
      "adapireqs": 863,
      "ads_VI": 127,
      "cmsPop": 167,
      "createdTs": 1769320815874,
      "createdYm": "202601",
      "deviceId": "1755584075228",
      "err_HI": 1,
      "err_VI": 76,
      "get_BO": 4315,
      "get_HI": 4315,
      "get_PX": 4315,
      "get_VI": 4315,
      "groupId": "1751725383150",
      "h00": 7,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 3,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 6,
      "h16": 5,
      "h17": 6,
      "h23": 6,
      "hf": 1769320815827,
      "id": "1755584075228-20260125",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_HI": {
        "body": {},
        "responseCode": 500
      },
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "lsd_VI": 127,
      "modifiedTs": 1769407173869,
      "modifiedYm": "202601",
      "pop_VI": 125,
      "period": "20260125",
      "statusByHour": [
        7,
        6,
        6,
        6,
        3,
        0,
        0,
        0,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        6,
        0,
        0,
        0,
        0,
        0,
        6
      ],
      "noOfhrsOnline": 15,
      "deviceCode": "DD-H7ST7E",
      "deviceTitle": "STAPLES_0063_HORIZ_1_DD_H7ST7E",
      "info": {}
    },
    {
      "adapireqs": 1045,
      "ads_VI": 158,
      "cmsPop": 202,
      "createdTs": 1769407213477,
      "createdYm": "202601",
      "deviceId": "1755584075228",
      "err_VI": 118,
      "get_BO": 5225,
      "get_HI": 5225,
      "get_PX": 5225,
      "get_VI": 5225,
      "groupId": "1751725383150",
      "h00": 7,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 3,
      "h07": 6,
      "h08": 6,
      "h09": 7,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 5,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h23": 6,
      "hf": 1769407213396,
      "id": "1755584075228-20260126",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "lsd_VI": 158,
      "modifiedTs": 1769493575802,
      "modifiedYm": "202601",
      "pop_VI": 158,
      "period": "20260126",
      "statusByHour": [
        7,
        6,
        6,
        6,
        3,
        0,
        0,
        6,
        6,
        7,
        6,
        6,
        6,
        6,
        6,
        5,
        6,
        6,
        6,
        0,
        0,
        0,
        0,
        6
      ],
      "noOfhrsOnline": 18,
      "deviceCode": "DD-H7ST7E",
      "deviceTitle": "STAPLES_0063_HORIZ_1_DD_H7ST7E",
      "info": {}
    },
    {
      "adapireqs": 1045,
      "ads_VI": 168,
      "cmsPop": 202,
      "createdTs": 1769493614778,
      "createdYm": "202601",
      "deviceId": "1755584075228",
      "err_PX": 15,
      "err_VI": 105,
      "get_BO": 5221,
      "get_HI": 5221,
      "get_PX": 5221,
      "get_VI": 5221,
      "groupId": "1751725383150",
      "h00": 7,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 3,
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 5,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h23": 6,
      "hf": 1769493614719,
      "id": "1755584075228-20260127",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_PX": {
        "body": {
          "message": "Geocode Error",
          "errors": [
            "Error resolving location data, Try again later"
          ]
        },
        "responseCode": 500
      },
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "lsd_VI": 168,
      "modifiedTs": 1769579975882,
      "modifiedYm": "202601",
      "pop_VI": 167,
      "period": "20260127",
      "statusByHour": [
        7,
        6,
        6,
        6,
        3,
        0,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        6,
        6,
        6,
        0,
        0,
        0,
        0,
        6
      ],
      "noOfhrsOnline": 18,
      "deviceCode": "DD-H7ST7E",
      "deviceTitle": "STAPLES_0063_HORIZ_1_DD_H7ST7E",
      "info": {}
    },
    {
      "adapireqs": 1044,
      "ads_VI": 159,
      "cmsPop": 201,
      "createdTs": 1769580015185,
      "createdYm": "202601",
      "deviceId": "1755584075228",
      "err_PX": 8,
      "err_VI": 104,
      "get_BO": 5220,
      "get_HI": 5220,
      "get_PX": 5220,
      "get_VI": 5220,
      "groupId": "1751725383150",
      "h00": 7,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 3,
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 5,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h23": 6,
      "hf": 1769580015132,
      "id": "1755584075228-20260128",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_PX": {
        "body": {
          "message": "Geocode Error",
          "errors": [
            "Error resolving location data, Try again later"
          ]
        },
        "responseCode": 500
      },
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "lsd_VI": 159,
      "modifiedTs": 1769666375570,
      "modifiedYm": "202601",
      "pop_VI": 159,
      "period": "20260128",
      "statusByHour": [
        7,
        6,
        6,
        6,
        3,
        0,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        6,
        6,
        6,
        0,
        0,
        0,
        0,
        6
      ],
      "noOfhrsOnline": 18,
      "deviceCode": "DD-H7ST7E",
      "deviceTitle": "STAPLES_0063_HORIZ_1_DD_H7ST7E",
      "info": {}
    },
    {
      "adapireqs": 1043,
      "ads_VI": 173,
      "cmsPop": 206,
      "createdTs": 1769666414950,
      "createdYm": "202601",
      "deviceId": "1755584075228",
      "err_VI": 70,
      "get_BO": 5215,
      "get_HI": 5215,
      "get_PX": 5215,
      "get_VI": 5215,
      "groupId": "1751725383150",
      "h00": 7,
      "h01": 6,
      "h02": 6,
      "h03": 6,
      "h04": 3,
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 5,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h23": 6,
      "hf": 1769666414898,
      "id": "1755584075228-20260129",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "lsd_VI": 173,
      "modifiedTs": 1769752775797,
      "modifiedYm": "202601",
      "pop_VI": 172,
      "period": "20260129",
      "statusByHour": [
        7,
        6,
        6,
        6,
        3,
        0,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        6,
        6,
        6,
        0,
        0,
        0,
        0,
        6
      ],
      "noOfhrsOnline": 18,
      "deviceCode": "DD-H7ST7E",
      "deviceTitle": "STAPLES_0063_HORIZ_1_DD_H7ST7E",
      "info": {}
    },
    {
      "adapireqs": 480,
      "createdTs": 1769356812739,
      "createdYm": "202601",
      "deviceId": "1755597081576",
      "err_HI": 2,
      "err_VI": 75,
      "get_BO": 2400,
      "get_HI": 2400,
      "get_PX": 2400,
      "get_VI": 2400,
      "groupId": "1751725383150",
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 6,
      "h16": 6,
      "h17": 6,
      "hf": 1769356812715,
      "id": "1755597081576-20260125",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_HI": {
        "body": "<html><head><title>502 Bad Gateway</title></head><body><center><h1>502 Bad Gateway</h1></center></body></html>",
        "responseCode": 502
      },
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "modifiedTs": 1769385573518,
      "modifiedYm": "202601",
      "period": "20260125",
      "statusByHour": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "noOfhrsOnline": 8,
      "deviceCode": "DD-HDTN0T",
      "deviceTitle": "STAPLES_0451_DD_HDTN0T",
      "info": {}
    },
    {
      "adapireqs": 840,
      "createdTs": 1769432444223,
      "createdYm": "202601",
      "deviceId": "1755597081576",
      "err_VI": 134,
      "get_BO": 4174,
      "get_HI": 4174,
      "get_PX": 4174,
      "get_VI": 4174,
      "groupId": "1751725383150",
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 5,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h19": 6,
      "h20": 6,
      "hf": 1769432444206,
      "id": "1755597081576-20260126",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "modifiedTs": 1769482805022,
      "modifiedYm": "202601",
      "period": "20260126",
      "statusByHour": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        6,
        6,
        6,
        6,
        6,
        0,
        0,
        0
      ],
      "noOfhrsOnline": 14,
      "deviceCode": "DD-HDTN0T",
      "deviceTitle": "STAPLES_0451_DD_HDTN0T",
      "info": {}
    },
    {
      "adapireqs": 840,
      "createdTs": 1769518843793,
      "createdYm": "202601",
      "deviceId": "1755597081576",
      "err_PX": 11,
      "err_VI": 153,
      "get_BO": 4180,
      "get_HI": 4180,
      "get_PX": 4180,
      "get_VI": 4180,
      "groupId": "1751725383150",
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 5,
      "h15": 6,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h19": 6,
      "h20": 6,
      "hf": 1769518843778,
      "id": "1755597081576-20260127",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_PX": {
        "body": {
          "message": "Geocode Error",
          "errors": [
            "Error resolving location data, Try again later"
          ]
        },
        "responseCode": 500
      },
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "modifiedTs": 1769569217950,
      "modifiedYm": "202601",
      "period": "20260127",
      "statusByHour": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        6,
        6,
        6,
        6,
        6,
        6,
        0,
        0,
        0
      ],
      "noOfhrsOnline": 14,
      "deviceCode": "DD-HDTN0T",
      "deviceTitle": "STAPLES_0451_DD_HDTN0T",
      "info": {}
    },
    {
      "adapireqs": 840,
      "createdTs": 1769605213133,
      "createdYm": "202601",
      "deviceId": "1755597081576",
      "err_PX": 4,
      "err_VI": 110,
      "get_BO": 4200,
      "get_HI": 4200,
      "get_PX": 4200,
      "get_VI": 4200,
      "groupId": "1751725383150",
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 6,
      "h15": 5,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h19": 6,
      "h20": 6,
      "hf": 1769605213115,
      "id": "1755597081576-20260128",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_PX": {
        "body": {
          "message": "Geocode Error",
          "errors": [
            "Error resolving location data, Try again later"
          ]
        },
        "responseCode": 500
      },
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "modifiedTs": 1769655573827,
      "modifiedYm": "202601",
      "period": "20260128",
      "statusByHour": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        6,
        6,
        6,
        6,
        6,
        0,
        0,
        0
      ],
      "noOfhrsOnline": 14,
      "deviceCode": "DD-HDTN0T",
      "deviceTitle": "STAPLES_0451_DD_HDTN0T",
      "info": {}
    },
    {
      "adapireqs": 840,
      "createdTs": 1769691641734,
      "createdYm": "202601",
      "deviceId": "1755597081576",
      "err_VI": 84,
      "get_BO": 4195,
      "get_HI": 4195,
      "get_PX": 4195,
      "get_VI": 4195,
      "groupId": "1751725383150",
      "h07": 6,
      "h08": 6,
      "h09": 6,
      "h10": 6,
      "h11": 6,
      "h12": 6,
      "h13": 6,
      "h14": 5,
      "h15": 6,
      "h16": 6,
      "h17": 6,
      "h18": 6,
      "h19": 6,
      "h20": 6,
      "hf": 1769691641717,
      "id": "1755597081576-20260129",
      "lastModifiedUserId": "ALLOWED-ANONYMOUS",
      "latestErr_VI": {
        "body": {
          "error": "Too Many Requests",
          "status": 429
        },
        "responseCode": 429
      },
      "modifiedTs": 1769742002407,
      "modifiedYm": "202601",
      "period": "20260129",
      "statusByHour": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        6,
        6,
        6,
        6,
        6,
        6,
        0,
        0,
        0
      ],
      "noOfhrsOnline": 14,
      "deviceCode": "DD-HDTN0T",
      "deviceTitle": "STAPLES_0451_DD_HDTN0T",
      "info": {}
    }
  ],
  "stats": {
    "totalGet": 177380,
    "totalErr": 1070,
    "totalPop": 781,
    "totalLsd": 785,
    "totalCmsPop": 978,
    "totalAdApiReqs": 8880,
    "totalAds": 785,
    "totalGet_AD": 0,
    "totalErr_AD": 0,
    "totalPop_AD": 0,
    "totalLsd_AD": 0,
    "totalAds_AD": 0,
    "totalGet_BO": 44345,
    "totalErr_BO": 0,
    "totalPop_BO": 0,
    "totalLsd_BO": 0,
    "totalAds_BO": 0,
    "totalGet_DD": 0,
    "totalErr_DD": 0,
    "totalPop_DD": 0,
    "totalLsd_DD": 0,
    "totalAds_DD": 0,
    "totalGet_CMS": 0,
    "totalErr_CMS": 0,
    "totalPop_CMS": 0,
    "totalLsd_CMS": 0,
    "totalAds_CMS": 0,
    "totalGet_FR": 0,
    "totalErr_FR": 0,
    "totalPop_FR": 0,
    "totalLsd_FR": 0,
    "totalAds_FR": 0,
    "totalGet_HI": 44345,
    "totalErr_HI": 3,
    "totalPop_HI": 0,
    "totalLsd_HI": 0,
    "totalAds_HI": 0,
    "totalGet_LO": 0,
    "totalErr_LO": 0,
    "totalPop_LO": 0,
    "totalLsd_LO": 0,
    "totalAds_LO": 0,
    "totalGet_PX": 44345,
    "totalErr_PX": 38,
    "totalPop_PX": 0,
    "totalLsd_PX": 0,
    "totalAds_PX": 0,
    "totalGet_VC": 0,
    "totalErr_VC": 0,
    "totalPop_VC": 0,
    "totalLsd_VC": 0,
    "totalAds_VC": 0,
    "totalGet_VI": 44345,
    "totalErr_VI": 1029,
    "totalPop_VI": 781,
    "totalLsd_VI": 785,
    "totalAds_VI": 785
  },
  "_apiversion": "1.0.52"
}

export const campaigns = {
  items: [
    {
      id: 32168541321,
      state: 'active',
      locationName: '1055 Sunset Blvd NE, Renton, WA 98056, USA',
      location: {
        lat: 47.38356626,
        lon: -122.2286496
      },
      radius: 20,
      openoohcategory: ['retail.convenience_store'],
      adsFrequency: 6,
      startTs: 1656613800000,
      endTs: 1664562600000,
      screens: 120
    },
    {
      id: 32168541321,
      state: 'active',
      locationName: '1055 Sunset Blvd NE, Renton, WA 98056, USA',
      location: {
        lat: 47.38356626,
        lon: -122.2286496
      },
      radius: 20,
      openoohcategory: ['retail.convenience_store'],
      adsFrequency: 6,
      startTs: 1656613800000,
      endTs: 1664562600000,
      screens: 13
    },
    {
      id: 32168541321,
      state: 'reviewing',
      locationName: '1055 Sunset Blvd NE, Renton, WA 98056, USA',
      location: {
        lat: 47.38356626,
        lon: -122.2286496
      },
      radius: 20,
      openoohcategory: ['retail.convenience_store'],
      adsFrequency: 6,
      startTs: 1656613800000,
      endTs: 1664562600000,
      screens: 11
    },
    {
      id: 32168541321,
      state: 'action required',
      locationName: '1055 Sunset Blvd NE, Renton, WA 98056, USA',
      location: {
        lat: 47.38356626,
        lon: -122.2286496
      },
      radius: 20,
      openoohcategory: ['retail.convenience_store'],
      adsFrequency: 6,
      startTs: 1656613800000,
      endTs: 1664562600000,
      screens: 19
    },
  ],
  stats: {
    active: 2,
    review: 4,
    inactive: 1,
    actionRequired: 3
  }
}
export const creatives = {
  "up": 9900,
    "items": [
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-pucrid5fbba9842d59fe77242e169b04078b8d",
            "groupId": "PRODUCT",
            "createdTs": 1785301076719,
            "durationsecs": 59,
            "mimetype": "video/mp4",
            "adUrl": "https://cdn-f.adsmoloco.com/G6lLlEuUQaMUFnOB/creative/ms4uwgz3_vxtwun8_qxvcbnjdveow4zww.mp4",
            "bitrate": 7605.53,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785301182418,
            "descr": "The ad promotes a fantasy combat mobile game. It features animated characters, demons, and combat scenes which are typical for this genre. The violence depicted is animated game violence and does not trigger the VIOLENCE_GORE tag. The attire in the first frame is revealing but stylized fantasy art and not explicit, therefore not triggering SEXUAL_CONTENT or LINGERIE_SWIMWEAR. Demons and the number '666' appear but are part of the fantasy antagonist theme and do not constitute RELIGION or OFFENSIVE_CONTENT.",
            "descr2": "666 77 Only 3% of players can make it to the top Come for the tactics. Stay for the heroes. Every upgrade makes you stronger. Every ultimate hits differently. HERO WARS 20 4 2 3 4 5 8 6 4 5 50 150 200 350 400 148 60 400 20 20 20 20 10 20 30 99 100 20 199 99 20 199 20 30 20 20 20 20 20 20 50 150 200 350 400 20 20 20 20 20 50 10 20 30 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4 4",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "nextersglobal.com"
            ],
            "adSystems": [
                "publica"
            ],
            "campaignNames": [
                "MCTV_Test_2",
                "462efdda6be2194e628f8d32f3d2eda8"
            ],
            "pricingCpm": "3.50",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "publica",
                "MCTV",
                "SpringServe",
                "VideoElephant",
                "Publica"
            ],
            "adTitle": "qpTjZpWXUyYborZi..XWWMbqsFfP1fKIfJ",
            "firstApprovalTs": 1785301076718,
            "leased": 18,
            "served": 20
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-pucrid335926a5b2a46b7e84ac3ff37c226e89",
            "groupId": "PRODUCT",
            "createdTs": 1785301062135,
            "durationsecs": 60,
            "mimetype": "video/mp4",
            "adUrl": "https://trackers.emtvssp.com/st-red?pid=6241&redirect_url=https%3A%2F%2Fcdn.emtvssp.com%2Fst%2F2026-07-29%2Fd26ae4f17b208a6e8708e7d8254ae4ad4e924ddc_1280x720.mp4",
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785301149816,
            "descr": "The ad promotes car sales for AutoNation Buick GMC Corpus Christi. No specific product or content tags were triggered based on the provided rules.",
            "descr2": "AutoNation Buick GMC Corpus Christi Pricing you can trust. Sweet Retreat Ice Cream Homemade Ice Cream Save now on your favorite models. New 2026 GMC Sierra 1500 AT4 4x4 $6761 off MSRP 0% APR Financing for 60 months Employee Pricing for All Over 1 million 5-star reviews. GMC WE CARE PROFESSIONAL GRADE On SPID between Airline & Nile Less stress. Buick GMC GME WE CARE PROFESSIONAL GRADE Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On SPID between Airline & Nile Buick GMC On S",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "schumachersubaruofdelray.com"
            ],
            "adSystems": [
                "emtvssp"
            ],
            "campaignNames": [
                "49314",
                "874c7a07-7896-4482-b8f0-b19f5d89c3de"
            ],
            "pricingCpm": "3.70",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "emtvssp",
                "Publica",
                "SpringServe",
                "VideoElephant",
                "Google DV360 (DBM)"
            ],
            "adTitle": "In-Stream Video",
            "firstApprovalTs": 1785301062134,
            "leased": 1,
            "dropped": 1
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PO"
                },
                {
                    "facetName": "iabCategories",
                    "facetValue": "IAB1"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-8919168d4e03264035193e74658e2b0cf59a56246fa9fcc620460e22d4c2593c",
            "groupId": "PRODUCT",
            "createdTs": 1785301010231,
            "durationsecs": 15,
            "mimetype": "video/mp4",
            "adUrl": "https://static.placeexchange.com/mc/8213bb33-c0fe-43db-b408-285022eadf4d/20260728/3985984806701985944.mp4?org_id=0f888c3e-ed94-4fce-9c00-27767f2f0cdd",
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PO",
            "admJbCmpltTs": 1785301084116,
            "descr": "The ad is for a hidden object game named 'Seekers Notes'. The visuals and text ('Explore the Unknown', 'Unlock Dark Night Enigmas', 'Step into Danger') create a mystery/adventure theme. No content or product-specific tags from the schema apply.",
            "descr2": "EXPLORE THE UNKNOWN UNLOCK DARK NIGHT ENIGMAS STEP INTO DANGER YOUR SHARP EYES CAN FINISH IT... Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Microsoft Download on the App Store Get it on Google Play Available on Galaxy Store available on amazon appstore Seekers Notes Hidden object game Seekers Notes DOWNLOAD NOW Get it on Micr",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "seekersnotes.com"
            ],
            "iabCategories": [
                "IAB1"
            ],
            "adSystems": [
                "placeexchange"
            ],
            "buyer": "oncoretv",
            "buyerSeat": "5364614",
            "pricingCpm": 1.98,
            "pricingCurrency": "USD",
            "adTechPartners": [
                "placeexchange",
                "PlaceExchange"
            ],
            "adTitle": "3adcc774-b45c-4957-99b4-aa268cc70699",
            "firstApprovalTs": 1785301010230,
            "leased": 11,
            "served": 11
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-pucrid7a35c0f678628685f3056ad1ab349e4d",
            "groupId": "PRODUCT",
            "createdTs": 1785300907119,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://cdn.flashtalking.com/188462/TYQLLV26757HLGBTQMY26RX2307DIGITALVIDNYDCPHL_640_360_700_2398_128_48000_-23.mp4?cb=1783960980000",
            "bitrate": 800.96,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785300975205,
            "descr": "The ads feature Lexus SUVs, highlighting models like RX Turbo, RX Plug-in Hybrid, and RX Hybrid. Lease and financing options are presented. No restricted or high-severity content is present.",
            "descr2": "RX TURBO RX PLUG-IN HYBRID RX HYBRID 2026 RX 350 PREMIUM AWD SELECT MODELS MONTHLY LEASE STARTING AT $559 36 mos. $4,999 due at signing - OR - FINANCING STARTING AT 4.99% APR LEXUS Experience Amazing lexus.com (exact text from fine print is unreadable but includes website and legal details for lease/finance offers) selected models 2026 RX 350 PREMIUM AWD select models RX TURBO RX PLUG-IN HYBRID RX HYBRID (Note: Some text may be repeated due to different frames showing similar elements, extracted for completeness.) (Note: some text like 'selected models' appeared multiple times across frames and is included as it appears.) (Note: 'lexus.com' was faintly visible in frame 9's fine print.) (Note: Fine print details are too small to transcribe accurately.) (Note: 'SELECT MODELS' appeared in frame 8, not 9.) (Note: 'selected models' text is from frame 8, not frame 9.) (Note: '2026 RX 350 PREMIUM AWD' is from frame 9) (Note: 'LEXUS' and 'Experience Amazing' are from frame 10) (Note: 'RX TURBO', 'RX PLUG-IN HYBRID', 'RX HYBRID' are from frame 8) (Note: '4.99% APR' and '$559' are from frame 9) (Note: The repetition in extracted_text is intended to reflect the content across all frames as per the instructions for verbatim transcription and including text from multiple frames.) (Note: the phrase 'selected models' appears twice, once in frame 8 and once in frame 9.) (Note: the phrase 'SELECT MODELS' is in frame 9, not frame 8.) (Note: The text 'selected models' is only present in Frame 8. Frame 9 has 'SELECT MODELS'.) (Note: the phrase 'selected models' appears in frame 8.) (Note: the phrase 'selected models' is not in frame 8, it is in frame 9.) (Note: 'SELECT MODELS' is in frame 9. 'selected models' is in frame 8.) (Note: The text 'selected models' is present in frame 8. 'SELECT MODELS' is present in frame 9.) (Note: The text 'selected models' in frame 8 is different from 'SELECT MODELS' in frame 9.) (Note: the phrase 'selected models' appears in frame 8 and 'SELECT MODELS' a",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "lexus.eu"
            ],
            "adSystems": [
                "FT"
            ],
            "pricingCpm": "3.25",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "FT",
                "Publica",
                "DoubleVerify",
                "doubleverify.com-omid"
            ],
            "adTitle": "Flashtalking",
            "firstApprovalTs": 1785300907118,
            "leased": 6,
            "served": 6
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                },
                {
                    "facetName": "tags",
                    "facetValue": "POLITICAL"
                }
            ],
            "id": "PRODUCT-pucriddfa8016204ed9d711c8d2dea7278deb0",
            "groupId": "PRODUCT",
            "createdTs": 1785300440499,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://gcdn.2mdn.net/videoplayback/id/df0b759282bf64c7/itag/346/source/web_video_ads/xpc/EgVovf3BOg%3D%3D/ctier/L/acao/yes/ip/0.0.0.0/ipbits/0/expire/3928501458/sparams/id,itag,source,xpc,ctier,acao,ip,ipbits,expire/signature/6B6776111167C34ACAD228B8DB8F1433736C3026.1F944E7BF2C349379FDBB677FB64077D0331201C/key/ck2/file/file.mp4",
            "bitrate": 0.18,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785300510133,
            "descr": "The ad features segments on 'Lifestyles of the Rich and Famous' and luxury items (airplane, car), investigative reporting critical of RUSH University Medical Center's CEO compensation versus employee layoffs, and a direct political advocacy campaign via HealthcareBetrayal.com sponsored by Save Our States Action. The HealthcareBetrayal.com segment clearly falls under POLITICAL due to its advocacy on a contentious issue (healthcare). The RUSH University Medical Center segment is critical reporting, not a direct promotion of the hospital, and does not trigger other specific tags. No other tags like SEXUAL_CONTENT, VIOLENCE_GORE, ALCOHOL, etc., are applicable.",
            "descr2": "Lifestyles of The Rich and Famous Glam RUSH University Medical Center CEO LATEEF $3.6 MILLION WHILE EMPLOYEES FACED LAYOFFS THE CEO ENJOYED CLUB MEMBERSHIPS ProPublica - Chicago Sun-Times HealthcareBetrayal.com PAID FOR BY SAVE OUR STATES ACTION CS-PHI 0215555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555555",
            "tags": [
                "POLITICAL"
            ],
            "validTags": [],
            "polSocScore": 8,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "healthcarebetrayal.com"
            ],
            "adSystems": [
                "DCM"
            ],
            "campaignNames": [
                "7"
            ],
            "pricingCpm": "3.25",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "DCM",
                "Publica",
                "Google DV360 (DBM)"
            ],
            "adTitle": "In-Stream Video",
            "firstApprovalTs": 1785300440499,
            "leased": 2,
            "served": 2
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PO"
                },
                {
                    "facetName": "iabCategories",
                    "facetValue": "IAB9"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                },
                {
                    "facetName": "tags",
                    "facetValue": "POLITICAL"
                },
                {
                    "facetName": "tags",
                    "facetValue": "QR_CODE"
                }
            ],
            "id": "PRODUCT-da615c0da7b9b3f79ce7f836f7c6ee96bf60593e09a170fad3ad1b8a6b7da2a2",
            "groupId": "PRODUCT",
            "createdTs": 1785300352021,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://static.placeexchange.com/mc/8213bb33-c0fe-43db-b408-285022eadf4d/20260728/7959661451151507281_high.mp4?org_id=0f888c3e-ed94-4fce-9c00-27767f2f0cdd",
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PO",
            "admJbCmpltTs": 1785300438603,
            "descr": "The ad promotes a game about international war and geopolitical conflicts involving multiple nations, which falls under the POLITICAL tag. A QR code is present in the final frame.",
            "descr2": "Player VS MEXICO CUTS DIPLOMATIC TIES INVADE MEXICO BUY MEXICO DO NOTHING SUPREMACY WORLD WAR III UNITED STATES CUBA DEPLOYS TROOPS AT THE BORDER BLAME VENEZUELA GIVE CUBA SOME NUKES NUKE CUBA CANADA EXITS NA STAY CALM BLAME THE UK INVADE CANADA DOWNLOAD HERE! PLAY NOW CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES CANADA UNITED STATES UNITED S",
            "tags": [
                "POLITICAL",
                "QR_CODE"
            ],
            "validTags": [],
            "polSocScore": 8,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "doradogames.com"
            ],
            "iabCategories": [
                "IAB9"
            ],
            "adSystems": [
                "placeexchange"
            ],
            "buyer": "oncoretv",
            "buyerSeat": "89535",
            "pricingCpm": 0.93582,
            "pricingCurrency": "USD",
            "adTechPartners": [
                "placeexchange",
                "PlaceExchange"
            ],
            "adTitle": "2b6b6464-5ae0-4891-8c2e-fb86291f4023",
            "firstApprovalTs": 1785300352021,
            "leased": 30,
            "served": 30
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-pucrida563d6767ea8e1be7652da61cd5a27f8",
            "groupId": "PRODUCT",
            "createdTs": 1785300200066,
            "durationsecs": 29,
            "mimetype": "video/mp4",
            "adUrl": "https://media.simpli.fi/ads/display/5c/48967903/e8d4b1f4c96f389d1bb019f70ee82a40/900x720px_2400kbps_tf3.mp4",
            "bitrate": 2559,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785300242615,
            "descr": "The ad promotes GMC trucks and financing offers from Gillman GMC. No high-severity or moderate content tags apply.",
            "descr2": "GREAT DEALS ON TRUCKSShop NowGillmanGMC.comTHE TRUCK YOU WANT AT ADEAL YOU LOVETHIS BRAND'SBACK GUARANTEETHE TRUCK YOU WANT AT ADEAL YOU LOVETHE TRUCK YOU WANT AT ADEAL YOU LOVETHE TRUCK YOU WANT AT ADEAL YOU LOVETHE TRUCK YOU WANT AT ADEAL YOU LOVETHE TRUCK YOU WANT AT ADEAL YOU LOVETHE TRUCK YOU WANT AT ADEAL YOU LOVETHE TRUCK YOU WANT AT ADEAL YOU LOVEThe GillmanPromiseHappy Car Buying Guaranteed2026 GMC Sierra1500 DenaliGet0.0%APRFor 36 MonthsGillmanGMC SINCE 1974Length of contract: 36 months. Monthly payment is $27.78 per $1,000 financed. Average example down payment is 10.75% (Total finance through GMC Financial). Some customers may not qualify. Tax, title, license and dealer fees extra. Take new retail delivery by 8/31/26. Vehicles purchased at the Gillman Automotive Group come with a Bring It Back Guarantee.Built Pre-Owned and Trade-in Vehicles must be returned in purchase condition within two miles or 200 miles. These vehicles of the current model year qualify for the Bring It Back Guarantee. The Bring It Back Guarantee is non-transferable and has no cash value. The demo vehicles are also available for personal vehicles with less than 30,000 miles and less than five years old. See dealer for details. Some restrictions apply.2026 GMC Sierra1500 DenaliGet0.0%APRFor 36 MonthsGillmanGMC SINCE 19742026 GMC Sierra1500 DenaliGet0.0%APRFor 36 MonthsGillmanGMC SINCE 1974www.GillmanGMC.comGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEGMCWE ARE PROFESSIONAL GRADEG",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "gillmanchevygmc.com"
            ],
            "adSystems": [
                "Simplifi"
            ],
            "campaignNames": [
                "1886498918129710408"
            ],
            "pricingCpm": "4.00",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "Simplifi",
                "Publica",
                "SpringServe",
                "appnexus.com-omid"
            ],
            "adTitle": "R6EGM511A7H.mp4",
            "firstApprovalTs": 1785300200065,
            "leased": 66,
            "served": 66
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-pucridc279786e09a30382b0ccf6a9757b1d65",
            "groupId": "PRODUCT",
            "createdTs": 1785300143107,
            "durationsecs": 60,
            "mimetype": "video/mp4",
            "adUrl": "https://trackers.emtvssp.com/st-red?pid=6241&redirect_url=https%3A%2F%2Fcdn.emtvssp.com%2Fst%2F2026-07-29%2Fc7a17cfb2a432eafb13de2c9b3b94fa29de566f8_1280x720.mp4",
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785300233877,
            "descr": "The ad is for a car dealership, AutoNation Toyota White Marsh. No specific product or content tags apply based on the provided rules.",
            "descr2": "AutoNation Toyota White Marsh SWEET RETREAT ICE CREAM HOMEMADE ICE CREAM Pricing you can trust. AN AutoNation Over 1 million 5-star reviews. Save now on your favorite models. New 2026 Toyota Camry LE FWD 6.99% APR Financing for 72 months or $289 per month + Tax - 36 Month Lease $3,999 Due at Signing TOYOTA On the corner of Klein Ave. & Belair Rd. Less stress. Pricing you can trust. AN Toyota AutoNation Toyota White Marsh TOYOTA On the corner of Klein Ave. & Belair Rd. AutoNation Toyota White Marsh Less stress. Toyota AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Pricing you can trust. AN AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Less stress. Toyota AutoNation Toyota White Marsh TOYOTA On the corner of Klein Ave. & Belair Rd. AutoNation Toyota White Marsh TOYOTA On the corner of Klein Ave. & Belair Rd. AutoNation Toyota White Marsh Less stress. Toyota AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Pricing you can trust. AN AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Less stress. Toyota AutoNation Toyota White Marsh TOYOTA On the corner of Klein Ave. & Belair Rd. AutoNation Toyota White Marsh TOYOTA On the corner of Klein Ave. & Belair Rd. AutoNation Toyota White Marsh Less stress. Toyota AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Pricing you can trust. AN AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Less stress. Toyota AutoNation Toyota White Marsh TOYOTA On the corner of Klein Ave. & Belair Rd. AutoNation Toyota White Marsh TOYOTA On the corner of Klein Ave. & Belair Rd. AutoNation Toyota White Marsh Less stress. Toyota AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Pricing you can trust. AN AutoNation Toyota White Marsh Toyota AutoNation Toyota White Marsh Less stress. Toyota AutoNation Toyota White Mars",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "schumachersubaruofdelray.com"
            ],
            "adSystems": [
                "emtvssp"
            ],
            "campaignNames": [
                "49314",
                "874c7a07-7896-4482-b8f0-b19f5d89c3de"
            ],
            "pricingCpm": "4.00",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "emtvssp",
                "Publica",
                "SpringServe",
                "VideoElephant",
                "Google DV360 (DBM)"
            ],
            "adTitle": "In-Stream Video",
            "firstApprovalTs": 1785300143106,
            "leased": 1,
            "dropped": 1
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-pucridd052664dff9a90d4875a6eb9322bd76a",
            "groupId": "PRODUCT",
            "createdTs": 1785300078567,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://gcdn.2mdn.net/videoplayback/id/c604a22920a1b1bc/itag/15/source/web_video_ads/xpc/EgVovf3BOg%3D%3D/ctier/L/acao/yes/ip/0.0.0.0/ipbits/0/expire/3929023803/sparams/id,itag,source,xpc,ctier,acao,ip,ipbits,expire/signature/90824E2BB89B8A8A680B789BFA85B945D7CF7DAF.81DAE639AFE24DF28CCC4DA5CB94B4A03CBDE6A6/key/ck2/file/file.mp4",
            "bitrate": 0.18,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785300157917,
            "descr": "The ad promotes 'ALL THE DROP' olive oil. Imagery includes food, an olive grove, and lifestyle scenes. No specific tags apply based on the content provided.",
            "descr2": "OLIVE OIL ALL THE DROP ALL IN A DROP TARTA DE APROX...?10 (PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE APPROX...)?10 ( PRICE",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "oliveoilsfromspain.org"
            ],
            "adSystems": [
                "DCM"
            ],
            "pricingCpm": "4.00",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "DCM",
                "Publica",
                "SpringServe",
                "Google DV360 (DBM)"
            ],
            "adTitle": "In-Stream Video",
            "firstApprovalTs": 1785300078566,
            "leased": 39,
            "served": 41
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                },
                {
                    "facetName": "tags",
                    "facetValue": "POLITICAL"
                },
                {
                    "facetName": "tags",
                    "facetValue": "VIOLENCE_GORE"
                }
            ],
            "id": "PRODUCT-pucrid2dc3f7c945c90e653ce2885d6e58cf6d",
            "groupId": "PRODUCT",
            "createdTs": 1785300020515,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://ak-act.pubmatic.com/ba2d2c13-e815-4e36-a932-f3b7d8341e0c_medium_1280x720.mp4",
            "bitrate": 3593.76,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785300097685,
            "descr": "The ads clearly promote political campaigns, featuring candidates like Vivek Ramaswamy, Rob McColley, and referencing Amy Acton. The imagery in the first frame depicts a burning car during a protest, which is indicative of real-world unrest or violence. The text 'INSPIRED VIOLENCE' in another frame, coupled with protest imagery and 'ICE' graffiti, reinforces the presence of themes related to violence within a political context.",
            "descr2": "ICE DOES THIS NOT FEEL LIKE AMY ACTON ECHOING INSPIRED VIOLENCE POLICE OHIO CAN'T AFFORD VIVEK BACKS LAW ENFORCEMENT VIVEK ENDORSED BY OHIO FRATERNAL ORDER OF POLICE PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO LOWER COSTS. BIGGER PAYCHECKS. VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO PAID FOR BY VIVEK RAMASWAMY AND ROB MCCOLLEY FOR OHIO VIVE FOR OHIO PAID FOR BY VIVEK RAMASWAMY",
            "tags": [
                "POLITICAL",
                "VIOLENCE_GORE"
            ],
            "validTags": [],
            "polSocScore": 8,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "vivekforohio.com"
            ],
            "adSystems": [
                "Martin AI"
            ],
            "campaignNames": [
                "Dalvik/2.1.0 (Linux; U; Android 6.0.1; MIBOX3 Build/MHC19J)"
            ],
            "pricingCpm": "4.00",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "Martin AI",
                "Publica",
                "SpringServe",
                "DoubleVerify"
            ],
            "adTitle": "VivekOH-SGM_EchoingRadicalLeftists_1920x1080.mp4",
            "firstApprovalTs": 1785300020514,
            "leased": 10,
            "served": 10
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                },
                {
                    "facetName": "tags",
                    "facetValue": "POLITICAL"
                }
            ],
            "id": "PRODUCT-pucrid57f2cc5a13de3eaf44b59873669fd2b7",
            "groupId": "PRODUCT",
            "createdTs": 1785300019035,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://gcdn.2mdn.net/videoplayback/id/a2bc662d288e0a31/itag/346/source/web_video_ads/xpc/EgVovf3BOg%3D%3D/ctier/L/acao/yes/ip/0.0.0.0/ipbits/0/expire/3928664520/sparams/id,itag,source,xpc,ctier,acao,ip,ipbits,expire/signature/36F2031DC988424650BB4941E70B33BE13DC5A1D.B457CD81E5BB7A6E98CF49E427B2497D2EA134FC/key/ck2/file/file.mp4",
            "bitrate": 0.18,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785300089866,
            "descr": "The ad promotes the candidacy of Juan Ciscomani for Congress, featuring his name and campaign statements. It also criticizes opponent Joanna Mendoza on issues such as 'men in girls' sports' and calls her 'toxic' and 'too extreme'. The POLITICAL tag is applied due to the campaign messaging and endorsement.",
            "descr2": "JUAN CISCOMANI CONGRESS KATIE MOM OF THREE GIRLS TUCSON JOANNA MENDOZA SUPPORTS MEN IN GIRLS' SPORTS Arizona Daily Star, 10/7/20 JOANNA MENDOZA CALLED PARENTS LIKE KATIE \"TOXIC\" JOANNA MENDOZA IS OUT OF TOUCH. TOO EXTREME FOR ARIZONA. APPROVED BY JUAN CISCOMANI PAID FOR BY CISCOMANI FOR CONGRESS",
            "tags": [
                "POLITICAL"
            ],
            "validTags": [],
            "polSocScore": 8,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "juanciscomani.com"
            ],
            "adSystems": [
                "DCM"
            ],
            "pricingCpm": "3.25",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "DCM",
                "Publica",
                "Google DV360 (DBM)"
            ],
            "adTitle": "In-Stream Video",
            "firstApprovalTs": 1785300019035,
            "leased": 5,
            "served": 5
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PO"
                },
                {
                    "facetName": "iabCategories",
                    "facetValue": "IAB20"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-c33c42f8bc2969cc1f616dc278598a521e7c3509bb4a2c586934e6799ac24199",
            "groupId": "PRODUCT",
            "createdTs": 1785299702410,
            "durationsecs": 15,
            "mimetype": "video/mp4",
            "adUrl": "https://static.placeexchange.com/mc/8213bb33-c0fe-43db-b408-285022eadf4d/20260728/17073685781601037002_high.mp4?org_id=0f888c3e-ed94-4fce-9c00-27767f2f0cdd",
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PO",
            "admJbCmpltTs": 1785299793551,
            "descr": "The ad promotes tourism for Fort Myers. Earlier frames show leisure activities like water slides and a pirate theme, likely to appeal to a broad audience including older adults. The swimwear is a modest one-piece, and the pirate costume elements are for entertainment and not promoting actual weapons. The website VISITFORTMYERS.COM is displayed.",
            "descr2": "FORT MYERS Just Feels Right VISITFORTMYERS.COM",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "visitfortmyers.com"
            ],
            "iabCategories": [
                "IAB20"
            ],
            "adSystems": [
                "placeexchange"
            ],
            "buyer": "oncoretv",
            "buyerSeat": "TremorVideo",
            "pricingCpm": 5.481,
            "pricingCurrency": "USD",
            "adTechPartners": [
                "placeexchange",
                "PlaceExchange"
            ],
            "adTitle": "905e7d0f-1f20-44ee-8aa1-7038fa236c37",
            "firstApprovalTs": 1785299702409,
            "leased": 2,
            "served": 2
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PO"
                },
                {
                    "facetName": "iabCategories",
                    "facetValue": "IAB1"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-37fcd02ff5a3e4002e2355174ae0ad4a4caf97ac7b59eae24b025ab9420663d4",
            "groupId": "PRODUCT",
            "createdTs": 1785299492411,
            "durationsecs": 15,
            "mimetype": "video/mp4",
            "adUrl": "https://static.placeexchange.com/mc/8213bb33-c0fe-43db-b408-285022eadf4d/20260728/12539989408804379602_high.mp4?org_id=0f888c3e-ed94-4fce-9c00-27767f2f0cdd",
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PO",
            "admJbCmpltTs": 1785299569108,
            "descr": "The ad promotes a TV show. While imagery of guns and dialogue about serial killers are present, the violence depicted is for a fictional crime drama and is not real violence or gore. Therefore, VIOLENCE_GORE and WEAPONS tags do not apply according to the rules, which require real violence or promotion of weapons as a product, respectively. No other applicable tags were detected.",
            "descr2": "Do you think it's possible to discern some hidden pattern shared by all serial killers?CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRIMINAL MINDS: EVOLUTIONParamount+Paramount+CRI",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "paramountplus.com"
            ],
            "iabCategories": [
                "IAB1"
            ],
            "adSystems": [
                "placeexchange"
            ],
            "buyer": "oncoretv",
            "buyerSeat": "TremorVideo",
            "pricingCpm": 8.21691,
            "pricingCurrency": "USD",
            "adTechPartners": [
                "placeexchange",
                "PlaceExchange"
            ],
            "adTitle": "2a069deb-e604-4219-b254-810577611eab",
            "firstApprovalTs": 1785299492410,
            "leased": 13,
            "served": 13
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PO"
                },
                {
                    "facetName": "iabCategories",
                    "facetValue": "IAB9"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                },
                {
                    "facetName": "tags",
                    "facetValue": "GAMBLING"
                },
                {
                    "facetName": "tags",
                    "facetValue": "QR_CODE"
                }
            ],
            "id": "PRODUCT-cb14c1b8fdc6f51e78252aa2118b642eb6ca98ae87dad037dbe033680e6c92bd",
            "groupId": "PRODUCT",
            "createdTs": 1785299194519,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://static.placeexchange.com/mc/8213bb33-c0fe-43db-b408-285022eadf4d/20260728/4644360762725335745_high.mp4?org_id=0f888c3e-ed94-4fce-9c00-27767f2f0cdd",
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PO",
            "admJbCmpltTs": 1785299282324,
            "descr": "The ad promotes a mobile game ('Cash Avalanche') that simulates slot machines and offers the chance to win real money, fitting the GAMBLING tag. A QR code is prominently displayed for users to scan and download the app, hence the QR_CODE tag. The game is not clearly targeted at children, despite some cartoon elements, and no other content tags apply.",
            "descr2": "SLOTS Cash Avalanche Go SCAN IT Download on the App Store PLAYING THIS SLOTS GAME CAN WIN YOU THIS MUCH You received: CASH OUT MINER'S FORTUNE FREE SPIN Each bonus for this game is 200 dollars YOU WON 50 FREE SPINS You can withdraw X 2X9 10 FREE GAME Take a minute to download and try it 20 FREE GAMES RANDOM You will get a 500 dollar cash bonus 50 FREE GAMES RANDOM Immediately withdraw directly to your account 70 no withdrawal limit EASILY WIN REAL PRIZE PLAY NOW The final result is not guaranteed, the amount you can obtain is subject to the rules published in the APP or web page. Payment received +$50.00 You received: $292.57 $415.91 $517.91 $641.25 $743.25 $866.60 $1,091.94 $1,193.94 $1,317.28 You received: $1,317.28 You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdraw You can withdr",
            "tags": [
                "GAMBLING",
                "QR_CODE"
            ],
            "validTags": [],
            "polSocScore": 4,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "rellgo.net"
            ],
            "iabCategories": [
                "IAB9"
            ],
            "adSystems": [
                "placeexchange"
            ],
            "buyer": "oncoretv",
            "buyerSeat": "63336037",
            "pricingCpm": 1.16991,
            "pricingCurrency": "USD",
            "adTechPartners": [
                "placeexchange",
                "PlaceExchange"
            ],
            "adTitle": "ae2581af-c705-4f2e-b141-b7783b58dece",
            "firstApprovalTs": 1785299194518,
            "leased": 308,
            "served": 308
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "IN"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-6e8294025ff6d3cc5daad775cb0b7380e7b7bbcbb6c1ae483da6575db864c6ae",
            "groupId": "PRODUCT",
            "createdTs": 1785299171550,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://cdn6.hootint.com/vid/75/15514/2596877_640k_640x360.mp4",
            "bitrate": 776.2,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "IN",
            "admJbCmpltTs": 1785299245976,
            "descr": "The ad frames promote a car dealership and various vehicles, including used and new cars and trucks with discounts. None of the specified tags apply based on the content.",
            "descr2": "Used 2025 Chevrolet Traverse $45,900 AVAILABLE NOW Shop now for best selection Behlmanncdjr.com Used 2021 Hyundai Palisade $31,900 RAM DISCOUNTS UP TO $20,000 OFF MSRP Used 2021 Jeep Cherokee $19,900 PLUS '26 Ram 1500 Crew $15,638 OFF MSRP Used 2023 CADILLAC XT4 $24,900 PLUS '26 Ram 2500 Crew $10,500 OFF MSRP Used 2015 Acura TLX $11,500 AVAILABLE NOW SHOP NOW Behlmann Chrysler Dodge Jeep Ram Hwy. 61 at Hwy. 47 in Troy, MO Used 2021 GMC Sierra 1500 $36,900 AVAILABLE NOW www.BehlmannCDJR.com YouCan Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for best selection Behlmanncdjr.com Shop now for ",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "api.hootvid.com"
            ],
            "adSystems": [
                "AdServer",
                "HootInteractive"
            ],
            "adTechPartners": [
                "AdServer",
                "Indicue",
                "HootInteractive",
                "DoubleVerify",
                "doubleverify.com-omid"
            ],
            "adTitle": "Behlmann CDJR Used Inventory",
            "firstApprovalTs": 1785299171549,
            "leased": 1,
            "served": 1
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                },
                {
                    "facetName": "tags",
                    "facetValue": "GAMBLING"
                },
                {
                    "facetName": "tags",
                    "facetValue": "QR_CODE"
                }
            ],
            "id": "PRODUCT-pucrid7803d35e799bbb0d387d9be980615abc",
            "groupId": "PRODUCT",
            "createdTs": 1785298998082,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://res.oa.opera.com/v/2026/7/21/15509159231232l1.mp4",
            "bitrate": 2062.14,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785310405204,
            "descr": "The ads promote the 'Grand Fortune Club' which is a gambling app, evident from the presence of slot machines, '777' symbols, multipliers, and game-related terminology. QR codes are present for downloading the app.",
            "descr2": "SCAN TO QR CODE TO PLAY NOW Grand Fortune Club App Store No purchase required. Void where prohibited by law. See Terms and Conditions. 18+ K POT 123,839,637,600 61,929,072,522 3,231,868,920 284,767,564 5X 10X 15X 2X ALL WINS SUPER WIN SC 236.15 COLLECT Available on the App Store SCAN CODE TO DOWNLOAD MY TAOIST PRAYERS WERE ANSWERED! 1000 GOLD ON MY FIRST SPIN LOL 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 777 77",
            "tags": [
                "GAMBLING",
                "QR_CODE"
            ],
            "validTags": [],
            "polSocScore": 4,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "apple.com",
                "grandfortunegame.com"
            ],
            "adSystems": [
                "benefitads"
            ],
            "pricingCpm": "4.00",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "benefitads",
                "Publica",
                "SpringServe",
                "DoubleVerify"
            ],
            "adTitle": "In-Stream Video",
            "firstApprovalTs": 1785298998081,
            "leased": 1,
            "served": 1
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "VS"
                },
                {
                    "facetName": "iabCategories",
                    "facetValue": "IAB17"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-88acacdd50aa9caa7b989bb255e9aad90ba7ad07952be1963df5c6f19503c9ef",
            "groupId": "PRODUCT",
            "createdTs": 1785298889502,
            "durationsecs": 59,
            "mimetype": "video/mp4",
            "adUrl": "https://cdn-f.adsmoloco.com/G6lLlEuUQaMUFnOB/creative/ms4uwgz3_vxtwun8_qxvcbnjdveow4zww.mp4",
            "bitrate": 7605.53,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "VS",
            "admJbCmpltTs": 1785298991547,
            "descr": "The ad displays animated combat scenes from a fantasy game, featuring demons and characters fighting. This falls under game violence, which is not tagged as VIOLENCE_GORE according to the rules. The demonic imagery and the number '666' are thematic elements of the fantasy game and do not constitute a religious promotion or endorsement, hence no RELIGION tag is applied. No other sensitive content or product tags are applicable.",
            "descr2": "Hero Wars Only 3% of players can make it to the top Every upgrade makes you stronger Come for the tactics. Stay for the heroes. 666 77 4 4 2 2 8 6 5 4 20 20 20 50 150 200 350 400 4 60 141 50 5 28 7 2 99 20 100 199 20 20 96 199 20 32 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 x3 ",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "iabCategories": [
                "IAB17"
            ],
            "adSystems": [
                "Vesta Rtb Solution"
            ],
            "pricingCpm": 4,
            "adTechPartners": [
                "Vesta Rtb Solution",
                "SpringServe"
            ],
            "firstApprovalTs": 1785298889501,
            "leased": 3,
            "dropped": 2
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PO"
                },
                {
                    "facetName": "iabCategories",
                    "facetValue": "IAB9"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "image/jpeg"
                },
                {
                    "facetName": "tags",
                    "facetValue": "GAMBLING"
                },
                {
                    "facetName": "tags",
                    "facetValue": "QR_CODE"
                }
            ],
            "id": "PRODUCT-e0464d89cdfe8326614c01ecd595e6cff7483f14e9ee2c76d2b38c8601f9920a",
            "groupId": "PRODUCT",
            "createdTs": 1785298706551,
            "durationsecs": 31,
            "mimetype": "image/jpeg",
            "adUrl": "https://static.placeexchange.com/e75bd76c-a093-4638-be2c-5c86e6106912/24947945/1785278670/1024x768.jpg?org_id=0f888c3e-ed94-4fce-9c00-27767f2f0cdd",
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PO",
            "admJbCmpltTs": 1785298803207,
            "descr": "GAMBLING tag applied due to prominent display of 'Prairie Band Casino & Resort' and the tagline 'Play Your Way', indicating the casino is a sponsor or venue being promoted. QR_CODE tag applied due to presence of a QR code.",
            "descr2": "KATHLEEN MADIGAN FLYING CATS & MARCHING ARMADILLOS 2026 TOUR October 22 Get Tickets > PLAY your WAY PRAIRIE BAND CASINO & RESORT",
            "tags": [
                "GAMBLING",
                "QR_CODE"
            ],
            "validTags": [],
            "polSocScore": 4,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "prairieband.com"
            ],
            "iabCategories": [
                "IAB9"
            ],
            "adSystems": [
                "placeexchange"
            ],
            "buyer": "viant",
            "buyerSeat": "2968",
            "pricingCpm": 17.22972474,
            "pricingCurrency": "USD",
            "adTechPartners": [
                "placeexchange",
                "PlaceExchange"
            ],
            "adTitle": "9cb1e486-c10f-4c80-89fd-6d1cc4de674a",
            "firstApprovalTs": 1785298706551,
            "leased": 55,
            "served": 55
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PO"
                },
                {
                    "facetName": "iabCategories",
                    "facetValue": "IAB9"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "image/jpeg"
                },
                {
                    "facetName": "tags",
                    "facetValue": "QR_CODE"
                }
            ],
            "id": "PRODUCT-6d414b3c1b4cccc8e66f5daa82d09e65182e3487b1ba28a9697edacb65a67873",
            "groupId": "PRODUCT",
            "createdTs": 1785298684940,
            "durationsecs": 31,
            "mimetype": "image/jpeg",
            "adUrl": "https://static.placeexchange.com/e75bd76c-a093-4638-be2c-5c86e6106912/24947948/1785278678/1400x400.jpg?org_id=0f888c3e-ed94-4fce-9c00-27767f2f0cdd",
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PO",
            "admJbCmpltTs": 1785303385938,
            "descr": "The ad promotes a comedy tour by Kathleen Madigan. A QR code is present on screen. No other tags apply based on the content.",
            "descr2": "KATHLEEN MADIGAN FLYING CATS & MARCHING ARMADILLOS 2026 TOUR October 22 Get Tickets > PLAY your WAY PRAIRIE BAND LIGHTING & SOUND PRAIRIE BAND CATERING & BEVERAGES LLC. (the small text under PRAIRIE BAND seems to say \"LIGHTING & SOUND\", the logo also has \"CATERING & BEVERAGES LLC\" visible below it, but it's too small to be certain about the full text, focusing on the main text. However, it's still too small to be sure of the exact wording, so I will omit it.) ACTUALLY, the smaller text below PRAIRIE BAND is indeed part of the logo for",
            "tags": [
                "QR_CODE"
            ],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "prairieband.com"
            ],
            "iabCategories": [
                "IAB9"
            ],
            "adSystems": [
                "placeexchange"
            ],
            "buyer": "viant",
            "buyerSeat": "2968",
            "pricingCpm": 17.22972474,
            "pricingCurrency": "USD",
            "adTechPartners": [
                "placeexchange",
                "PlaceExchange"
            ],
            "adTitle": "756a81bf-265f-45db-b810-a637ff41f740",
            "firstApprovalTs": 1785298684939,
            "leased": 61,
            "served": 61
        },
        {
            "facet": [
                {
                    "facetName": "state",
                    "facetValue": "APPROVED"
                },
                {
                    "facetName": "exchange",
                    "facetValue": "PU"
                },
                {
                    "facetName": "orientation",
                    "facetValue": "landscape"
                },
                {
                    "facetName": "mimetype",
                    "facetValue": "video/mp4"
                }
            ],
            "id": "PRODUCT-pucrid77fcf5f3cd4fdcea2fd906ca9b2f2619",
            "groupId": "PRODUCT",
            "createdTs": 1785298628910,
            "durationsecs": 30,
            "mimetype": "video/mp4",
            "adUrl": "https://s-static.innovid.com/media/encoded/07_26/1306651/2_source_232634_1502268.mp4",
            "bitrate": 982.08,
            "orientation": "landscape",
            "state": "APPROVED",
            "exchange": "PU",
            "admJbCmpltTs": 1785298702741,
            "descr": "The ad promotes a health monitoring device (Stelo by Dexcom) for managing glucose levels. None of the specific product or content tags apply based on the provided rules. The device shows real-time glucose readings and activity tracking, but does not promote illegal drugs, alcohol, smoking, gambling, violence, political content, or sexual content. It is a medical/health product.",
            "descr2": "stelo by Dexcom Continuous data availability, for the life app compatibility, and data consistency TIME IN RANGE 94% SO FAR TODAY GLUCOSE 122 mg/dL stelo Find what fuels you. Discover more at Stelo.com STELO IMPORTANT INFORMATION For full information on benefits and risks, visit Stelo.com. Stelo, Stelo Clarity, Stelo Clarity follow, Stelo One, Stelo Share, and any related logos and design marks are other registered trademarks or trademarks of Dexcom, Inc. in the United States and/or other countries. MKT-1451 ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** ** *",
            "tags": [],
            "validTags": [],
            "polSocScore": 0,
            "admJbStatus": "COMPLETED",
            "advertiserDomains": [
                "stelo.com"
            ],
            "adSystems": [
                "Innovid Ads"
            ],
            "pricingCpm": "3.50",
            "pricingCurrency": "USD",
            "adTechPartners": [
                "Innovid Ads",
                "Publica",
                "SpringServe",
                "VideoElephant",
                "Indicue",
                "DoubleVerify",
                "doubleverify.com-omid",
                "Google DV360 (DBM)"
            ],
            "adTitle": "Dexcom_Stelo_Multisite_FWFY_1920x1080 (16x9)_30s_NA",
            "firstApprovalTs": 1785298628909,
            "leased": 1,
            "served": 1
        }
    ],
    "stats": {
        "count": 624,
        "facets": [
            {
                "key": "exchange",
                "values": [
                    {
                        "value": "PU",
                        "count": 295
                    },
                    {
                        "value": "PO",
                        "count": 179
                    },
                    {
                        "value": "VS",
                        "count": 132
                    },
                    {
                        "value": "IN",
                        "count": 18
                    }
                ]
            },
            {
                "key": "mimetype",
                "values": [
                    {
                        "value": "video/mp4",
                        "count": 560
                    },
                    {
                        "value": "application/javascript",
                        "count": 37
                    },
                    {
                        "value": "image/jpeg",
                        "count": 21
                    },
                    {
                        "value": "application/x-mpegURL",
                        "count": 4
                    },
                    {
                        "value": "video/quicktime",
                        "count": 1
                    },
                    {
                        "value": "video/webm",
                        "count": 1
                    }
                ]
            },
            {
                "key": "orientation",
                "values": [
                    {
                        "value": "landscape",
                        "count": 612
                    },
                    {
                        "value": "portrait",
                        "count": 12
                    }
                ]
            },
            {
                "key": "iabCategories",
                "values": [
                    {
                        "value": "IAB17",
                        "count": 87
                    },
                    {
                        "value": "IAB9",
                        "count": 51
                    },
                    {
                        "value": "IAB1",
                        "count": 39
                    },
                    {
                        "value": "IAB3",
                        "count": 24
                    },
                    {
                        "value": "IAB20",
                        "count": 19
                    },
                    {
                        "value": "IAB22",
                        "count": 13
                    },
                    {
                        "value": "IAB2",
                        "count": 10
                    },
                    {
                        "value": "IAB10",
                        "count": 9
                    },
                    {
                        "value": "IAB8",
                        "count": 9
                    },
                    {
                        "value": "IAB7",
                        "count": 8
                    },
                    {
                        "value": "IAB11",
                        "count": 6
                    },
                    {
                        "value": "IAB13",
                        "count": 5
                    },
                    {
                        "value": "IAB19",
                        "count": 5
                    },
                    {
                        "value": "IAB-17",
                        "count": 2
                    },
                    {
                        "value": "IAB21",
                        "count": 2
                    },
                    {
                        "value": "IAB24",
                        "count": 2
                    },
                    {
                        "value": "IAB5",
                        "count": 2
                    },
                    {
                        "value": "IAB18",
                        "count": 1
                    }
                ]
            },
            {
                "key": "tags",
                "values": [
                    {
                        "value": "QR_CODE",
                        "count": 123
                    },
                    {
                        "value": "GAMBLING",
                        "count": 58
                    },
                    {
                        "value": "POLITICAL",
                        "count": 34
                    },
                    {
                        "value": "LINGERIE_SWIMWEAR",
                        "count": 7
                    },
                    {
                        "value": "VIOLENCE_GORE",
                        "count": 7
                    },
                    {
                        "value": "AMBIGUOUS",
                        "count": 6
                    },
                    {
                        "value": "ALCOHOL",
                        "count": 5
                    },
                    {
                        "value": "CONVENIENCE_STORE_DETECTED",
                        "count": 3
                    },
                    {
                        "value": "SEXUAL_CONTENT",
                        "count": 3
                    },
                    {
                        "value": "DRUGS_ILLEGAL",
                        "count": 2
                    },
                    {
                        "value": "OFFENSIVE_CONTENT",
                        "count": 2
                    },
                    {
                        "value": "RELIGION",
                        "count": 2
                    },
                    {
                        "value": "SMOKING",
                        "count": 2
                    },
                    {
                        "value": "WEAPONS",
                        "count": 2
                    }
                ]
            },
            {
                "key": "adRating",
                "values": [
                    {
                        "value": "PG-13",
                        "count": 1
                    },
                    {
                        "value": "TV-PG",
                        "count": 1
                    },
                    {
                        "value": "tv-14",
                        "count": 1
                    }
                ]
            }
        ],
        "durationDistribution": [
            {
                "key": "below10",
                "label": "below10",
                "count": 6
            },
            {
                "key": "from10below20",
                "label": "from10below20",
                "count": 159
            },
            {
                "key": "from20below30",
                "label": "from20below30",
                "count": 32
            },
            {
                "key": "from30below40",
                "label": "from30below40",
                "count": 375
            },
            {
                "key": "from40below60",
                "label": "from40below60",
                "count": 14
            },
            {
                "key": "from60up",
                "label": "from60up",
                "count": 38
            }
        ],
        "bitrateDistribution": [
            {
                "key": "below5",
                "label": "below5",
                "count": 330
            },
            {
                "key": "from5below10",
                "label": "from5below10",
                "count": 14
            },
            {
                "key": "from10below15",
                "label": "from10below15",
                "count": 10
            },
            {
                "key": "from15below20",
                "label": "from15below20",
                "count": 21
            },
            {
                "key": "from20below50",
                "label": "from20below50",
                "count": 6
            },
            {
                "key": "from50up",
                "label": "from50up",
                "count": 0
            }
        ]
    },
    "nextPage": "{\"from\":20}",
    "_apiversion": "1.0.52"
//   assets: [
//   {
//     id: '1751725383150-3cf2ea524446ef8ec9d85b29c216e086873496252089b633d28e65428c979d03',
//     title: 'Image - 12/15/2025 07:00:07 AM CST',
//     url: 'https://d3txy5owctt379.cloudfront.net/c47de640-d9a2-11f0-bb05-8511fa7550cc.jpg',
//     state: 'HOLD',
//     createdTs: 1765803607554,
//     width: 1080,
//     height: 1920,
//     durationsecs: 15,
//     mimetype: 'image/jpg',
//     creativeId: '3cf2ea524446ef8ec9d85b29c216e086873496252089b633d28e65428c979d03',
//     pop: 10,
//     leased: 15,
//     served: 10
//   },
//   {
//     id: '1751725383150-3cf2ea524446ef8ec9d85b29c216e086873496252089b633d28e65428c979d03',
//     title: 'Image - 12/15/2025 07:00:07 AM CST',
//     url: 'https://transcodes-cdn.vistarmedia.com/r7OMg7EHQVKHLqCgd2SNVA/r7OMg7EHQVKHLqCgd2SNVA.mp4',
//     state: 'APPROVED',
//     createdTs: 1759371668573,
//     width: 1080,
//     height: 1920,
//     durationsecs: 15,
//     mimetype: 'video/mp4',
//     creativeId: '0457ba3f360efd39d35d6fe06f7fc8cfe23c53cdadc12db15ae6c5f036b4148a',
//     pop: 14,
//     leased: 15,
//     served: 14
//   },
//   {
//     id: '1751725383150-7644966c7e4663cbf12967b372ee6c56375a0e01709c396474ea55b97bb859de',
//     title: 'Image - 10/01/2025 07:29:21 PM CDT',
//     url: 'https://static.placeexchange.com/dda6b2ac-c5f0-4ba6-8186-849e6618cdec/ox8gj1ko/1758037198/840x400.jpg',
//     state: 'APPROVED',
//     createdTs: 1759371668573,
//     width: 840,
//     height: 400,
//     durationsecs: 30,
//     mimetype: 'image/jpg',
//     creativeId: '7644966c7e4663cbf12967b372ee6c56375a0e01709c396474ea55b97bb859de',
//     pop: 10,
//     leased: 25,
//     served: 19
//   },
//     {
//     id: '1751725383150-c3599bb5db809511d30661eddb79093e70c7d44f197a3e1e8e967faabd816d0e',
//     title: 'Image - 10/01/2025 07:30:04 PM CDT',
//     url: 'https://static.placeexchange.com/dda6b2ac-c5f0-4ba6-8186-849e6618cdec/k38xrvlz/1758866984/1920x1080.jpg',
//     state: 'APPROVED',
//     createdTs: 1759365004869,
//     width: 1920,
//     height: 1080,
//     durationsecs: 30,
//     mimetype: 'image/jpg',
//     creativeId: 'c3599bb5db809511d30661eddb79093e70c7d44f197a3e1e8e967faabd816d0e',
//     pop: 200,
//     leased: 215,
//     served: 210
//   },
// ]
}

export const contentreview = {
  items: [
    {
      id: 1,
      title: 'Title One',
      description: 'Description test one',
      category: 'Category1',
      link: 'https://d1bpnn2a5id540.cloudfront.net/1667202251714/f6b3a870-e2c4-11ed-b4ec-51dc0f75592e.jpg',
      iType: 'IMAGE'
    },
    {
      id: 2,
      title: 'Title Two',
      description: 'Description test two',
      category: 'Category2',
      link: 'https://d3txy5owctt379.cloudfront.net/1690349875526/a1311c8a-8bcc-432b-b533-e3cf7ceb530c_1728897861203.mp4',
      iType: 'VIDEO'

    },
    {
      id: 3,
      title: 'Title Three',
      description: 'Description test three',
      category: 'Category3',
      link: 'https://d1bpnn2a5id540.cloudfront.net/1667202251714/f6b3a870-e2c4-11ed-b4ec-51dc0f75592e.jpg',
      iType: 'IMAGE'

    }
  ],
  fieldDefCampaignApproval: {
        steps: [
            {
                fields: [
                    {
                        key: "updateAction",
                        type: "radio",
                        label: "Action",
                        hint: "Select Action",
                        options: [
                            {
                                key: "approve",
                                label: "approve"
                            },
                            {
                                key: "disapprove",
                                label: "disapprove"
                            },
                            {
                                key: "enable",
                                label: "enable"
                            },
                            {
                                key: "disable",
                                label: "pause"
                            }
                        ],
                        v_required: {
                            value: true,
                            err: "Select Action"
                        },
                        placement: "left",
                        multiSelect: false,
                        value: "",
                        valid: true
                    }
                ]
            }
        ],
        formType: "edit"
    }

}

export const campaign = {
  locationName: '28559 Sunset Blvd NE, Renton, WA 98056, USA',
  location: {
    lat: 47.38356626,
    lon: -122.2286496
  },
  radius: 13,
  openoohcategory: ['retail.convenience_store', 'retail.grocery.check_out'],
  adsFrequency: 6,
  startTs: 1656613800000,
  endTs: 1664562600000,
  neverEnding: false,
  "fieldDef": {
    title: 'Creatives',
    formType: 'add',
    "steps": [
      {
        "fields": [
          {
            "key": "title",
            "type": "edit_text",
            "label": "Title",
            "hint": "Provide title",
            "v_required": {
              "value": true,
              "err": "Provide title"
            },
            "v_min": {
              "value": 2,
              "err": "Title is too short (2 - 100)"
            },
            "v_max": {
              "value": 100,
              "err": "Title is too long (2 - 100)"
            },
            "placement": "left"
          },
          {
            "key": "image",
            "linkName": "logo",
            "type": "edit_text",
            "label": "Image (1200 px width)(png)",
            "imageWidth": 1200,
            "hint": "Upload the image",
            "v_required": {
              "value": false,
              "err": "Upload the Logo"
            },
            "v_min": {
              "value": 1,
              "err": "Invalid Image"
            },
            "v_max": {
              "value": 100,
              "err": "Invalid Image"
            },
            "mode": "fit",
            "imageUpload": true,
            "uploadType": "media",
            "uploadAccept": "image/png, image/jpeg",
            "placement": "left"
          }
        ]
      }
    ]
  },
  adImages: [
    {
      image: 'https://d1bpnn2a5id540.cloudfront.net/1667202251714/f6b3a870-e2c4-11ed-b4ec-51dc0f75592e.jpg',
      imageName: 'DUMMY_IMAGE_MOCK.png',
      title: 'Lorem Ipsum'
    }
  ],
  "items": [
    // {
    //   "id": "1680530758470",
    //   "state": "LIVE",
    //   "deviceCode": "DD-E8294B",
    //   "title": "HD002_148_DD_E8294B",
    //   "descr": "HD002 148 DD E8294B",
    //   "titleForAnalyser": "HD002_148_DD_E8294B",
    //   "address": "4211 Preston-Fall City Rd SE, Fall City, WA 98024",
    //   "location": {
    //     "lat": 47.5671376,
    //     "lon": -121.8881308
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98024"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Fall City"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    // {
    //   "id": "1678477998445",
    //   "state": "LIVE",
    //   "deviceCode": "DD-248F4F",
    //   "title": "WA001_09_DD_248F4F",
    //   "descr": "WA001 09 DD 248F4F",
    //   "titleForAnalyser": "WA001_09_DD_248F4F",
    //   "address": "35505 Pacific Hwy S, Federal Way, WA 98003",
    //   "location": {
    //     "lat": 47.28303623,
    //     "lon": -122.3230018
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98003"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Federal Way"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    // {
    //   "id": "1678997297462",
    //   "state": "LIVE",
    //   "deviceCode": "DD-7146F6",
    //   "title": "WA001_112_DD_7146F6",
    //   "descr": "WA001 112 DD 7146F6",
    //   "titleForAnalyser": "WA001_112_DD_7146F6",
    //   "address": "7909 Rainier Ave S, Seattle, WA 98118",
    //   "location": {
    //     "lat": 47.5312798,
    //     "lon": -122.2701633
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98118"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Seattle"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },

    // {
    //   "id": "1678997546983",
    //   "state": "LIVE",
    //   "deviceCode": "DD-63F275",
    //   "title": "WA001_114_DD_63F275",
    //   "descr": "WA001 114 DD 63F275",
    //   "titleForAnalyser": "WA001_114_DD_63F275",
    //   "address": "3420 SW 320th St # B-1, Federal Way, WA 98023",
    //   "location": {
    //     "lat": 47.31419997,
    //     "lon": -122.3750588
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98023"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Federal Way"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    // {
    //   "id": "1678997897480",
    //   "state": "LIVE",
    //   "deviceCode": "DD-43FC82",
    //   "title": "WA001-121-DD-43FC82",
    //   "descr": "WA001-121-DD-43FC82",
    //   "titleForAnalyser": "WA001-121-DD-43FC82",
    //   "address": "3100 E Madison St, Seattle, WA 98112",
    //   "location": {
    //     "lat": 47.62653769,
    //     "lon": -122.2920939
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98112"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Seattle"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    // {
    //   "id": "1678997981412",
    //   "state": "LIVE",
    //   "deviceCode": "DD-3F2026",
    //   "title": "WA001-122-DD-3F2026",
    //   "descr": "WA001-122-DD-3F2026",
    //   "titleForAnalyser": "WA001-122-DD-3F2026",
    //   "address": "105 S 156th St, Burien, WA 98148",
    //   "location": {
    //     "lat": 47.46304152,
    //     "lon": -122.3334136
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98148"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Burien"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    // {
    //   "id": "1678997997695",
    //   "state": "LIVE",
    //   "deviceCode": "DD-62724C",
    //   "title": "WA001-123-Horiz-DD-62724C",
    //   "descr": "WA001-123-Horiz-DD-62724C",
    //   "titleForAnalyser": "WA001-123-Horiz-DD-62724C",
    //   "address": "3306 S 170th St, SeaTac, WA 98188",
    //   "location": {
    //     "lat": 47.45134912,
    //     "lon": -122.2899965
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98188"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "SeaTac"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    // {
    //   "id": "1678998042029",
    //   "state": "LIVE",
    //   "deviceCode": "DD-0C8008",
    //   "title": "WA001-125-DD-0C8008",
    //   "descr": "WA001-125-DD-0C8008",
    //   "titleForAnalyser": "WA001-125-DD-0C8008",
    //   "address": "15060 Pacific Hwy S, Tukwila, WA 98188",
    //   "location": {
    //     "lat": 47.46724841,
    //     "lon": -122.287551
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98188"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Tukwila"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    // {
    //   "id": "1678998470063",
    //   "state": "LIVE",
    //   "deviceCode": "DD-657287",
    //   "title": "WA001-129-Horiz-DD-657287",
    //   "descr": "WA001-129-Horiz-DD-657287",
    //   "titleForAnalyser": "WA001-129-Horiz-DD-657287",
    //   "address": "320 1st Ave N, Algona, WA 98001",
    //   "location": {
    //     "lat": 47.278988,
    //     "lon": -122.2501777
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98001"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Algona"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    // {
    //   "id": "1678998718907",
    //   "state": "LIVE",
    //   "deviceCode": "DD-0D05C6",
    //   "title": "WA001-132-DD-0D05C6",
    //   "descr": "WA001-132-DD-0D05C6",
    //   "titleForAnalyser": "WA001-132-DD-0D05C6",
    //   "address": "4580 Fauntleroy Way SW, Seattle, WA 98126",
    //   "location": {
    //     "lat": 47.56133992,
    //     "lon": -122.3809899
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98126"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Seattle"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    // {
    //   "id": "1678998735523",
    //   "state": "LIVE",
    //   "deviceCode": "DD-643513",
    //   "title": "WA001_133_DD_643513",
    //   "descr": "WA001 133 DD 643513",
    //   "titleForAnalyser": "WA001_133_DD_643513",
    //   "address": "11611 NE 8th St, Bellevue, WA 98005",
    //   "location": {
    //     "lat": 47.61704251,
    //     "lon": -122.1848403
    //   },
    //   "facet": [
    //     {
    //       "facetName": "width",
    //       "facetValue": "1080"
    //     },
    //     {
    //       "facetName": "height",
    //       "facetValue": "1920"
    //     },
    //     {
    //       "facetName": "openoohcategory",
    //       "facetValue": "retail.convenience_store"
    //     },
    //     {
    //       "facetName": "zip",
    //       "facetValue": "98005"
    //     },
    //     {
    //       "facetName": "city",
    //       "facetValue": "Bellevue"
    //     },
    //     {
    //       "facetName": "countrycode",
    //       "facetValue": "US"
    //     },
    //     {
    //       "facetName": "dmacode",
    //       "facetValue": "819"
    //     },
    //     {
    //       "facetName": "statecode",
    //       "facetValue": "WA"
    //     }
    //   ]
    // },
    {
      "id": "1680530810605",
      "state": "LIVE",
      "deviceCode": "DD-C67222",
      "title": "WA001-135-DD-C67222",
      "descr": "WA001-135-DD-C67222",
      "titleForAnalyser": "WA001-135-DD-C67222",
      "address": "2461 4th Ave S, Seattle, WA 98134",
      "location": {
        "lat": 47.57998672,
        "lon": -122.3296042
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98134"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530811025",
      "state": "LIVE",
      "deviceCode": "DD-7F5522",
      "title": "WA001_180_DD_7F5522",
      "descr": "WA001 180 DD 7F5522",
      "titleForAnalyser": "WA001_180_DD_7F5522",
      "address": "7630 NE Bothell Way, Kenmore, WA 98028",
      "location": {
        "lat": 47.75665986,
        "lon": -122.2375874
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98028"
        },
        {
          "facetName": "city",
          "facetValue": "Kenmore"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530811076",
      "state": "LIVE",
      "deviceCode": "DD-8457D6",
      "title": "WA001_181_DD_8457D6",
      "descr": "WA001 181 DD 8457D6",
      "titleForAnalyser": "WA001_181_DD_8457D6",
      "address": "255 Central Way, Kirkland, WA 98033",
      "location": {
        "lat": 47.67706119,
        "lon": -122.2036598
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98033"
        },
        {
          "facetName": "city",
          "facetValue": "Kirkland"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530811169",
      "state": "LIVE",
      "deviceCode": "DD-535082",
      "title": "WA001_185_Horiz_DD_535082",
      "descr": "WA001 185 Horiz DD 535082",
      "titleForAnalyser": "WA001_185_Horiz_DD_535082",
      "address": "12116 Juanita Dr NE, Kirkland, WA 98034",
      "location": {
        "lat": 47.70922878,
        "lon": -122.2373224
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1920"
        },
        {
          "facetName": "height",
          "facetValue": "1080"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98034"
        },
        {
          "facetName": "city",
          "facetValue": "Kirkland"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530811620",
      "state": "LIVE",
      "deviceCode": "DD-323F1C",
      "title": "WA001_194_DD_323F1C",
      "descr": "WA001 194 DD 323F1C",
      "titleForAnalyser": "WA001_194_DD_323F1C",
      "address": "406 Central Way, Kirkland, WA 98033",
      "location": {
        "lat": 47.67842434,
        "lon": -122.2008634
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98033"
        },
        {
          "facetName": "city",
          "facetValue": "Kirkland"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530811876",
      "state": "LIVE",
      "deviceCode": "DD-23C809",
      "title": "WA001_258_DD_23C809",
      "descr": "WA001 258 DD 23C809",
      "titleForAnalyser": "WA001_258_DD_23C809",
      "address": "757 Rainier Ave S, Renton, WA 98057",
      "location": {
        "lat": 47.47148824,
        "lon": -122.2187246
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98057"
        },
        {
          "facetName": "city",
          "facetValue": "Renton"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530811968",
      "state": "LIVE",
      "deviceCode": "DD-4DA2A4",
      "title": "WA001_260_DD_4DA2A4",
      "descr": "WA001 260 DD 4DA2A4",
      "titleForAnalyser": "WA001_260_DD_4DA2A4",
      "address": "8315 S 212th St, Kent, WA 98032",
      "location": {
        "lat": 47.41177329,
        "lon": -122.2286633
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98032"
        },
        {
          "facetName": "city",
          "facetValue": "Kent"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530812056",
      "state": "LIVE",
      "deviceCode": "DD-7B8005",
      "title": "WA001_263_DD_7B8005",
      "descr": "WA001 263 DD 7B8005",
      "titleForAnalyser": "WA001_263_DD_7B8005",
      "address": "810 Harvey Rd, Auburn, WA 98002",
      "location": {
        "lat": 47.31557832,
        "lon": -122.2142064
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98002"
        },
        {
          "facetName": "city",
          "facetValue": "Auburn"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530812178",
      "state": "LIVE",
      "deviceCode": "DD-8AB049",
      "title": "WA001_269_DD_8AB049",
      "descr": "WA001 269 DD 8AB049",
      "titleForAnalyser": "WA001_269_DD_8AB049",
      "address": "16827 Bothell Way NE, Lake Forest Park, WA 98155",
      "location": {
        "lat": 47.7516645,
        "lon": -122.2817624
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98155"
        },
        {
          "facetName": "city",
          "facetValue": "Lake Forest Park"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530812319",
      "state": "LIVE",
      "deviceCode": "DD-A4D95C",
      "title": "WA001_285_DD_A4D95C",
      "descr": "WA001 285 DD A4D95C",
      "titleForAnalyser": "WA001_285_DD_A4D95C",
      "address": "601 S Grady Way STE B, Renton, WA 98057",
      "location": {
        "lat": 47.47168795,
        "lon": -122.2110742
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98057"
        },
        {
          "facetName": "city",
          "facetValue": "Renton"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530812362",
      "state": "LIVE",
      "deviceCode": "DD-383397",
      "title": "WA001_286_DD_383397",
      "descr": "WA001 286 DD 383397",
      "titleForAnalyser": "WA001_286_DD_383397",
      "address": "19246 15th Ave NE, Shoreline, WA 98155",
      "location": {
        "lat": 47.76982,
        "lon": -122.31353
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98155"
        },
        {
          "facetName": "city",
          "facetValue": "Shoreline"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530812601",
      "state": "LIVE",
      "deviceCode": "DD-3AA243",
      "title": "WA001_291_DD_3AA243",
      "descr": "WA001 291 DD 3AA243",
      "titleForAnalyser": "WA001_291_DD_3AA243",
      "address": "6600 Martin Luther King Jr Way S, Seattle, WA 98118",
      "location": {
        "lat": 47.54296989,
        "lon": -122.283685
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98118"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1680530812731",
      "state": "LIVE",
      "deviceCode": "DD-75BDFA",
      "title": "WA001_307_DD_75BDFA",
      "descr": "WA001 307 DD 75BDFA",
      "titleForAnalyser": "WA001_307_DD_75BDFA",
      "address": "19803 1st Ave S, Normandy Park, WA 98148",
      "location": {
        "lat": 47.42459582,
        "lon": -122.3363634
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98148"
        },
        {
          "facetName": "city",
          "facetValue": "Normandy Park"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678651648665",
      "state": "LIVE",
      "deviceCode": "DD-DF2081",
      "title": "WA001_39_DD_DF2081",
      "descr": "WA001 39 DD DF2081",
      "titleForAnalyser": "WA001_39_DD_DF2081",
      "address": "21620 Marine View Dr S, Des Moines, WA 98198",
      "location": {
        "lat": 47.40786544,
        "lon": -122.3251973
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98198"
        },
        {
          "facetName": "city",
          "facetValue": "Des Moines"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678657370125",
      "state": "LIVE",
      "deviceCode": "DD-A24408",
      "title": "WA001_59_DD_A24408",
      "descr": "WA001 59 DD A24408",
      "titleForAnalyser": "WA001_59_DD_A24408",
      "address": "16402 Military Rd S, Seattle, WA 98188",
      "location": {
        "lat": 47.45604195,
        "lon": -122.2809148
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98188"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678657406920",
      "state": "LIVE",
      "deviceCode": "DD-2412F6",
      "title": "WA001_60_DD_2412F6",
      "descr": "WA001 60 DD 2412F6",
      "titleForAnalyser": "WA001_60_DD_2412F6",
      "address": "174 Stewart Rd SE, Pacific, WA 98047",
      "location": {
        "lat": 47.24999553,
        "lon": -122.2526407
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98047"
        },
        {
          "facetName": "city",
          "facetValue": "Pacific"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678657471331",
      "state": "LIVE",
      "deviceCode": "DD-208F33",
      "title": "Outlet Collection Chevron Food mart",
      "descr": "Outlet Collection Chevron Food mart",
      "titleForAnalyser": "Outlet Collection Chevron Food mart",
      "address": "1402 Outlet Collection Way, Auburn, WA 98001",
      "location": {
        "lat": 47.29649324,
        "lon": -122.2503767
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98001"
        },
        {
          "facetName": "city",
          "facetValue": "Auburn"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678657515332",
      "state": "LIVE",
      "deviceCode": "DD-D07F8A",
      "title": "WA001_65_DD_D07F8A",
      "descr": "WA001 65 DD D07F8A",
      "titleForAnalyser": "WA001_65_DD_D07F8A",
      "address": "1151 Valentine Ave SE, Pacific, WA 98047",
      "location": {
        "lat": 47.24959158,
        "lon": -122.2482521
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98047"
        },
        {
          "facetName": "city",
          "facetValue": "Pacific"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678657531196",
      "state": "LIVE",
      "deviceCode": "DD-5054F6",
      "title": "Boulevard Park Chevron",
      "descr": "Boulevard Park Chevron",
      "titleForAnalyser": "Boulevard Park Chevron",
      "address": "805 S 112th St, Seattle, WA 98168",
      "location": {
        "lat": 47.5026976,
        "lon": -122.3226155
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98168"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678657547408",
      "state": "LIVE",
      "deviceCode": "DD-CC178D",
      "title": "Food Mart",
      "descr": "Food Mart",
      "titleForAnalyser": "Food Mart",
      "address": "6056 Martin L King Jr Way S &, S Graham St, Seattle, WA 98118",
      "location": {
        "lat": 47.54296919,
        "lon": -122.2836789
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98118"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678658065053",
      "state": "LIVE",
      "deviceCode": "DD-0C34F6",
      "title": "WA001_69_DD_0C34F6",
      "descr": "WA001 69 DD 0C34F6",
      "titleForAnalyser": "WA001_69_DD_0C34F6",
      "address": "7219 Rainier Ave S, Seattle, WA 98118",
      "location": {
        "lat": 47.53786703,
        "lon": -122.2709264
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98118"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678658083013",
      "state": "LIVE",
      "deviceCode": "DD-F4368F",
      "title": "WA001_70_DD_F4368F",
      "descr": "WA001 70 DD F4368F",
      "titleForAnalyser": "WA001_70_DD_F4368F",
      "address": "7801 Detroit Ave SW, Seattle, WA 98106",
      "location": {
        "lat": 47.53233786,
        "lon": -122.3358443
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98106"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678658183169",
      "state": "LIVE",
      "deviceCode": "DD-01D436",
      "title": "WA001_74_DD_01D436",
      "descr": "WA001 74 DD 01D436",
      "titleForAnalyser": "WA001_74_DD_01D436",
      "address": "6815 Rainier Ave S, Seattle, WA 98118",
      "location": {
        "lat": 47.54101005,
        "lon": -122.2721771
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98118"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678658213333",
      "state": "LIVE",
      "deviceCode": "DD-847855",
      "title": "WA001_76_DD_847855",
      "descr": "WA001 76 DD 847855",
      "titleForAnalyser": "WA001_76_DD_847855",
      "address": "5041 Rainier Ave S, Seattle, WA 98118",
      "location": {
        "lat": 47.55621148,
        "lon": -122.2842117
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98118"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678658245820",
      "state": "LIVE",
      "deviceCode": "DD-70940D",
      "title": "South Park Chevron",
      "descr": "South Park Chevron",
      "titleForAnalyser": "South Park Chevron",
      "address": "8819 14th Ave S, Seattle, WA 98108",
      "location": {
        "lat": 47.52413208,
        "lon": -122.3154755
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98108"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678658281936",
      "state": "LIVE",
      "deviceCode": "DD-411656",
      "title": "WA001_79_DD_411656",
      "descr": "WA001 79 DD 411656",
      "titleForAnalyser": "WA001_79_DD_411656",
      "address": "6056 Martin Luther King Jr Way S, Seattle, WA 98118",
      "location": {
        "lat": 47.54638415,
        "lon": -122.2854181
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98118"
        },
        {
          "facetName": "city",
          "facetValue": "Seattle"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678658433803",
      "state": "LIVE",
      "deviceCode": "DD-30343C",
      "title": "Benson Smoke Shop",
      "descr": "Benson Smoke Shop",
      "titleForAnalyser": "Benson Smoke Shop",
      "address": "21006 108th Ave SE, Kent, WA 98031",
      "location": {
        "lat": 47.41394006,
        "lon": -122.1956934
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98031"
        },
        {
          "facetName": "city",
          "facetValue": "Kent"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678658450065",
      "state": "LIVE",
      "deviceCode": "DD-D4C75D",
      "title": "212th Chevron",
      "descr": "212th Chevron",
      "titleForAnalyser": "212th Chevron",
      "address": "8315 S 212th St, Kent, WA 98032",
      "location": {
        "lat": 47.41183137,
        "lon": -122.2285881
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98032"
        },
        {
          "facetName": "city",
          "facetValue": "Kent"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678738781881",
      "state": "LIVE",
      "deviceCode": "DD-51F185",
      "title": "WA001_90_DD_51F185",
      "descr": "WA001 90 DD 51F185",
      "titleForAnalyser": "WA001_90_DD_51F185",
      "address": "505 Meridian Ave E, Edgewood, WA 98371",
      "location": {
        "lat": 47.25287116,
        "lon": -122.2932367
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98371"
        },
        {
          "facetName": "city",
          "facetValue": "Edgewood"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678738797325",
      "state": "LIVE",
      "deviceCode": "DD-1A72F3",
      "title": "WA001_91_DD_1A72F3",
      "descr": "WA001 91 DD 1A72F3",
      "titleForAnalyser": "WA001_91_DD_1A72F3",
      "address": "5148 Auburn Way N, Auburn, WA 98002",
      "location": {
        "lat": 47.35340111,
        "lon": -122.2284742
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98002"
        },
        {
          "facetName": "city",
          "facetValue": "Auburn"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    },
    {
      "id": "1678740185407",
      "state": "LIVE",
      "deviceCode": "DD-772463",
      "title": "WA001_96_DD_772463",
      "descr": "WA001 96 DD 772463",
      "titleForAnalyser": "WA001_96_DD_772463",
      "address": "5800 Southcenter Blvd, Tukwila, WA 98188",
      "location": {
        "lat": 47.46411197,
        "lon": -122.2600831
      },
      "facet": [
        {
          "facetName": "width",
          "facetValue": "1080"
        },
        {
          "facetName": "height",
          "facetValue": "1920"
        },
        {
          "facetName": "openoohcategory",
          "facetValue": "retail.convenience_store"
        },
        {
          "facetName": "zip",
          "facetValue": "98188"
        },
        {
          "facetName": "city",
          "facetValue": "Tukwila"
        },
        {
          "facetName": "countrycode",
          "facetValue": "US"
        },
        {
          "facetName": "dmacode",
          "facetValue": "819"
        },
        {
          "facetName": "statecode",
          "facetValue": "WA"
        }
      ]
    }
  ]
}

const courses = [
  {
    id: '1653898475176',
    slug: 'course-a',
    title: 'Course A',
    descr: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book'
  },
  {
    id: '1653898492096',
    slug: 'course-b',
    title: 'course B',
    descr: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book'
  }
]

export const paymentUrl = {
  link: `https://payment.example.com/pay?amount=${encodeURIComponent(1000)}&ref=${Date.now()}`
}

export const MockData = {
    dayparting: [
  {
    url: 'https://d3txy5owctt379.cloudfront.net/c47de640-d9a2-11f0-bb05-8511fa7550cc.jpg',
    id: '1751725383150-3cf2ea524446ef8ec9d85b29c216e086873496252089b633d28e65428c979d03',
    image: 'https://d3txy5owctt379.cloudfront.net/c47de640-d9a2-11f0-bb05-8511fa7550cc.jpg',
    durationSecs: 15,
    mimetype: 'image/jpg',
    startTime: 0
  },
  {
    url: 'https://static.placeexchange.com/dda6b2ac-c5f0-4ba6-8186-849e6618cdec/ox8gj1ko/1758037198/840x400.jpg',
    id: '1751725383150-7644966c7e4663cbf12967b372ee6c56375a0e01709c396474ea55b97bb859de',
    image: 'https://static.placeexchange.com/dda6b2ac-c5f0-4ba6-8186-849e6618cdec/ox8gj1ko/1758037198/840x400.jpg',
    durationSecs: 30,
    mimetype: 'image/jpg',
    startTime: 15
  },
  {
    url: 'https://static.placeexchange.com/mc/8213bb33-c0fe-43db-b408-285022eadf4d/20260609/13537081289552208896.mp4',
    id: '1750308118959-PO1782798196432',
    image: 'https://d3txy5owctt379.cloudfront.net/c47de640-d9a2-11f0-bb05-8511fa7550cc.jpg',
    durationSecs: 30,
    mimetype: 'video/mp4',
    startTime: 45
  },
  {
    url: 'https://static.placeexchange.com/8213bb33-c0fe-43db-b408-285022eadf4d/aarki-82/15859e50-62ed-4112-8db7-f722f59ca1f6.mp4',
    id: '1750308118959-PO1782798081659',
    image: 'https://static.placeexchange.com/dda6b2ac-c5f0-4ba6-8186-849e6618cdec/ox8gj1ko/1758037198/840x400.jpg',
    durationSecs: 30,
    mimetype: 'video/mp4',
    startTime: 75
  }
],
  screenPerformanceDashboard: {
  statsTotal: {
    screens: 1000,
    cmsSpots: 560,
    ottSpots: 495,
    oohSpots: 577,

    cmsMinutes: 870,
    ottMinutes: 1030,
    oohMinutes: 1310,

    avgUtilization: 71,
    avgOnlineHours: 16
  },

  statsDay: {
    "20260616": {
      cmsSpots: 80,
      ottSpots: 90,
      oohSpots: 100,

      cmsMinutes: 120,
      ottMinutes: 180,
      oohMinutes: 240,

      onlineMinutes: 15.5*60,
      utilization: 68,

      playbackDistribution: {
        CMS: {
          "0-300": 90,
          "301-600": 120,
          "601-900": 45
        },
        OTT: {
          "0-300": 75,
          "301-600": 105,
          "601-900": 60
        },
        OOH: {
          "0-300": 60,
          "301-600": 130,
          "601-900": 70
        }
      }
    },

    "20260617": {
      cmsSpots: 120,
      ottSpots: 70,
      oohSpots: 140,

      cmsMinutes: 180,
      ottMinutes: 140,
      oohMinutes: 310,

      onlineMinutes: 16.2*60,
      utilization: 73,

      playbackDistribution: {
        CMS: {
          "0-300": 85,
          "301-600": 135,
          "601-900": 50
        },
        OTT: {
          "0-300": 65,
          "301-600": 120,
          "601-900": 55
        },
        OOH: {
          "0-300": 70,
          "301-600": 145,
          "601-900": 75
        }
      }
    },

    "20260618": {
      cmsSpots: 95,
      ottSpots: 115,
      oohSpots: 90,

      cmsMinutes: 150,
      ottMinutes: 220,
      oohMinutes: 210,

      onlineMinutes: 15.8*60,
      utilization: 71,

      playbackDistribution: {
        CMS: {
          "0-300": 95,
          "301-600": 110,
          "601-900": 40
        },
        OTT: {
          "0-300": 80,
          "301-600": 135,
          "601-900": 65
        },
        OOH: {
          "0-300": 65,
          "301-600": 120,
          "601-900": 55
        }
      }
    },

    "20260619": {
      cmsSpots: 135,
      ottSpots: 120,
      oohSpots: 110,

      cmsMinutes: 210,
      ottMinutes: 250,
      oohMinutes: 280,

      onlineMinutes: 16.8*60,
      utilization: 77,

      playbackDistribution: {
        CMS: {
          "0-300": 75,
          "301-600": 155,
          "601-900": 70
        },
        OTT: {
          "0-300": 70,
          "301-600": 160,
          "601-900": 80
        },
        OOH: {
          "0-300": 60,
          "301-600": 170,
          "601-900": 90
        }
      }
    },

    "20260620": {
      cmsSpots: 130,
      ottSpots: 100,
      oohSpots: 137,

      cmsMinutes: 210,
      ottMinutes: 240,
      oohMinutes: 270,

      onlineMinutes: 18*60,
      utilization: 75,

      playbackDistribution: {
        CMS: {
          "0-300": 80,
          "301-600": 150,
          "601-900": 65
        },
        OTT: {
          "0-300": 75,
          "301-600": 145,
          "601-900": 70
        },
        OOH: {
          "0-300": 65,
          "301-600": 160,
          "601-900": 85
        }
      }
    }
  },

  tableData: [
    {
      venueCode: "DD-004949",
      siteTitle: "India Bazaar Frisco",
      siteAddress: "8998 Preston Rd, Frisco, TX 75034",
      cmsSpots: 3313,
      cmsMinutes: 757.33,
      ottSpots: 883,
      ottMinutes: 40.35,
      oohSpots: 437,
      oohMinutes: 40.35,
      onlineHours: 23
    },
    {
      venueCode: "DD-004950",
      siteTitle: "India Bazaar Plano",
      siteAddress: "832 W Spring Creek Pkwy, Plano, TX",
      cmsSpots: 2840,
      cmsMinutes: 640.12,
      ottSpots: 940,
      ottMinutes: 46.82,
      oohSpots: 512,
      oohMinutes: 48.15,
      onlineHours: 22
    },
    {
      venueCode: "DD-004951",
      siteTitle: "India Bazaar Irving",
      siteAddress: "1420 W Walnut Hill Ln, Irving, TX",
      cmsSpots: 2986,
      cmsMinutes: 701.55,
      ottSpots: 1022,
      ottMinutes: 51.72,
      oohSpots: 468,
      oohMinutes: 44.63,
      onlineHours: 21
    },
    {
      venueCode: "DD-004952",
      siteTitle: "India Bazaar Dallas",
      siteAddress: "2615 W Pioneer Pkwy, Dallas, TX",
      cmsSpots: 3150,
      cmsMinutes: 734.82,
      ottSpots: 911,
      ottMinutes: 43.91,
      oohSpots: 490,
      oohMinutes: 46.11,
      onlineHours: 24
    }
  ]
  },

  dpActivity2: {
  "stats": {
    "totalGet": 44,
    "totalErr": 21,
    "totalPop": 1,
    "totalLsd": 6,
    "totalCmsPop": 12,
    "totalAds": 6,
    "totalGet_AD": 0,
    "totalErr_AD": 0,
    "totalPop_AD": 0,
    "totalLsd_AD": 0,
    "totalAds_AD": 0,
    "totalGet_BO": 5,
    "totalErr_BO": 0,
    "totalPop_BO": 0,
    "totalLsd_BO": 0,
    "totalAds_BO": 0,
    "totalGet_DD": 0,
    "totalErr_DD": 0,
    "totalPop_DD": 0,
    "totalLsd_DD": 0,
    "totalAds_DD": 0,
    "totalGet_CMS": 0,
    "totalErr_CMS": 0,
    "totalPop_CMS": 0,
    "totalLsd_CMS": 0,
    "totalAds_CMS": 0,
    "totalGet_FR": 0,
    "totalErr_FR": 0,
    "totalPop_FR": 0,
    "totalLsd_FR": 0,
    "totalAds_FR": 0,
    "totalGet_HI": 5,
    "totalErr_HI": 5,
    "totalPop_HI": 0,
    "totalLsd_HI": 0,
    "totalAds_HI": 0,
    "totalGet_LO": 0,
    "totalErr_LO": 0,
    "totalPop_LO": 0,
    "totalLsd_LO": 0,
    "totalAds_LO": 0,
    "totalGet_PX": 11,
    "totalErr_PX": 5,
    "totalPop_PX": 0,
    "totalLsd_PX": 6,
    "totalAds_PX": 6,
    "totalGet_VC": 0,
    "totalErr_VC": 0,
    "totalPop_VC": 0,
    "totalLsd_VC": 0,
    "totalAds_VC": 0,
    "totalGet_VI": 23,
    "totalErr_VI": 11,
    "totalPop_VI": 1,
    "totalLsd_VI": 0,
    "totalAds_VI": 0
  },
  "items": [
    {
      "period": "20250817",
      "cmsPop": 2,
      "day_cmsPop": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "day_get_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_VI": 3,
      "day_lsd_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_VI": 0,
      "day_ads_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_VI": 0,
      "day_err_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_VI": 1,
      "day_pop_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_VI": 0,
      "day_get_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_PX": 1,
      "day_lsd_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_PX": 1,
      "day_ads_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_PX": 1,
      "day_err_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_PX": 0,
      "day_pop_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_PX": 0,
      "day_get_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_HI": 0,
      "day_lsd_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_HI": 0,
      "day_ads_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_HI": 0,
      "day_err_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_HI": 0,
      "day_pop_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_HI": 0,
      "day_get_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_BO": 0,
      "day_lsd_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_BO": 0,
      "day_ads_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_BO": 0,
      "day_err_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_BO": 0,
      "day_pop_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_BO": 0,
      "day_get_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_D1": 0,
      "day_lsd_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_D1": 0,
      "day_ads_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_D1": 0,
      "day_err_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_D1": 0,
      "day_pop_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_D1": 0,
      "day_get_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_DT": 0,
      "day_lsd_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_DT": 0,
      "day_ads_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_DT": 0,
      "day_err_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_DT": 0,
      "day_pop_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_DT": 0
    },
    {
      "period": "20250819",
      "cmsPop": 4,
      "day_cmsPop": [
        0,
        0,
        0,
        0,
        0,
        0,
        4,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "day_get_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        6,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_VI": 7,
      "day_lsd_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_VI": 0,
      "day_ads_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_VI": 0,
      "day_err_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_VI": 3,
      "day_pop_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_VI": 1,
      "day_get_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_PX": 3,
      "day_lsd_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_PX": 2,
      "day_ads_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_PX": 2,
      "day_err_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_PX": 1,
      "day_pop_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_PX": 0,
      "day_get_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_HI": 1,
      "day_lsd_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_HI": 0,
      "day_ads_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_HI": 0,
      "day_err_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_HI": 1,
      "day_pop_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_HI": 0,
      "day_get_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_BO": 1,
      "day_lsd_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_BO": 0,
      "day_ads_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_BO": 0,
      "day_err_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_BO": 0,
      "day_pop_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_BO": 0,
      "day_get_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_D1": 0,
      "day_lsd_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_D1": 0,
      "day_ads_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_D1": 0,
      "day_err_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_D1": 0,
      "day_pop_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_D1": 0,
      "day_get_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "get_DT": 0,
      "day_lsd_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_DT": 0,
      "day_ads_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_DT": 0,
      "day_err_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_DT": 0,
      "day_pop_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_DT": 0
    },
    {
      "period": "20250902",
      "cmsPop": 6,
      "day_cmsPop": [
        0,
        0,
        0,
        0,
        0,
        6,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "day_get_VI": [
        0,
        0,
        0,
        0,
        0,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0
      ],
      "get_VI": 13,
      "day_lsd_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_VI": 0,
      "day_ads_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_VI": 0,
      "day_err_VI": [
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0
      ],
      "err_VI": 7,
      "day_pop_VI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_VI": 0,
      "day_get_PX": [
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0
      ],
      "get_PX": 7,
      "day_lsd_PX": [
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_PX": 3,
      "day_ads_PX": [
        0,
        0,
        0,
        0,
        0,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_PX": 3,
      "day_err_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0
      ],
      "err_PX": 4,
      "day_pop_PX": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_PX": 0,
      "day_get_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0
      ],
      "get_HI": 4,
      "day_lsd_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_HI": 0,
      "day_ads_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_HI": 0,
      "day_err_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0
      ],
      "err_HI": 4,
      "day_pop_HI": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_HI": 0,
      "day_get_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        2,
        0
      ],
      "get_BO": 4,
      "day_lsd_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_BO": 0,
      "day_ads_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_BO": 0,
      "day_err_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_BO": 0,
      "day_pop_BO": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_BO": 0,
      "day_get_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        6,
        0
      ],
      "get_D1": 10,
      "day_lsd_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        3,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_D1": 4,
      "day_ads_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        3,
        9,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_D1": 12,
      "day_err_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_D1": 0,
      "day_pop_D1": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        0
      ],
      "pop_D1": 1,
      "day_get_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        1,
        11,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        6,
        0
      ],
      "get_DT": 18,
      "day_lsd_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "lsd_DT": 0,
      "day_ads_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "ads_DT": 0,
      "day_err_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "err_DT": 0,
      "day_pop_DT": [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
      ],
      "pop_DT": 0
    }
  ],
  "_apiversion": "1.0.52"
},
  dpActivity: {
    "items": [
      {
        "modifiedYm": "202508",
        "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
        "cmsPop": 2,
        "createdYm": "202508",
        "period": "20250820",
        "get_VI": 3,
        "createdTs": 1755605483780,
        "err_VI": 1,
        "modifiedTs": 1755605483780,
        "ads_PX": 1,
        "get_PX": 1,
        "id": "20250817-13",
        "lsd_PX": 1,
        "hourlyData": [
          {
            "modifiedYm": "202508",
            "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
            "cmsPop": 2,
            "createdYm": "202508",
            "period": "20250820",
            "get_VI": 3,
            "createdTs": 1755605483780,
            "err_VI": 1,
            "modifiedTs": 1755605483780,
            "hour": "00",
            "ads_PX": 1,
            "get_PX": 1,
            "id": "20250817-13",
            "lsd_PX": 1
          },
          {
            "lastModifiedUserId": "ALLOWED-ANONYMOUS",
            "modifiedYm": "202508",
            "get_HI": 1,
            "err_HI": 1,
            "createdYm": "202508",
            "period": "20250819",
            "get_VI": 1,
            "createdTs": 1755615050667,
            "err_VI": 1,
            "modifiedTs": 1755615294018,
            "pop_VI": 1,
            "err_PX": 1,
            "get_BO": 1,
            "hour": "01",
            "get_PX": 1,
            "id": "20250819-09"
          },
          {
            "modifiedYm": "202508",
            "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
            "cmsPop": 2,
            "createdYm": "202508",
            "period": "20250820",
            "get_VI": 3,
            "createdTs": 1755605483780,
            "err_VI": 1,
            "modifiedTs": 1755605483780,
            "hour": "02",
            "ads_PX": 1,
            "get_PX": 1,
            "id": "20250817-13",
            "lsd_PX": 1
          },
          {
            "lastModifiedUserId": "ALLOWED-ANONYMOUS",
            "modifiedYm": "202508",
            "get_HI": 1,
            "err_HI": 1,
            "createdYm": "202508",
            "period": "20250819",
            "get_VI": 1,
            "createdTs": 1755615050667,
            "err_VI": 1,
            "modifiedTs": 1755615294018,
            "pop_VI": 1,
            "err_PX": 1,
            "get_BO": 1,
            "hour": "03",
            "get_PX": 1,
            "id": "20250819-09"
          },
          {
            "modifiedYm": "202508",
            "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
            "cmsPop": 2,
            "createdYm": "202508",
            "period": "20250820",
            "get_VI": 3,
            "createdTs": 1755605483780,
            "err_VI": 1,
            "modifiedTs": 1755605483780,
            "hour": "04",
            "ads_PX": 1,
            "get_PX": 1,
            "id": "20250817-13",
            "lsd_PX": 1
          },
          {
            "lastModifiedUserId": "ALLOWED-ANONYMOUS",
            "modifiedYm": "202508",
            "get_HI": 1,
            "err_HI": 1,
            "createdYm": "202508",
            "period": "20250819",
            "get_VI": 1,
            "createdTs": 1755615050667,
            "err_VI": 1,
            "modifiedTs": 1755615294018,
            "pop_VI": 1,
            "err_PX": 1,
            "get_BO": 1,
            "hour": "05",
            "get_PX": 1,
            "id": "20250819-09"
          },
          {
            "modifiedYm": "202508",
            "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
            "cmsPop": 2,
            "createdYm": "202508",
            "period": "20250820",
            "get_VI": 3,
            "createdTs": 1755605483780,
            "err_VI": 1,
            "modifiedTs": 1755605483780,
            "hour": "06",
            "ads_PX": 1,
            "get_PX": 1,
            "id": "20250817-13",
            "lsd_PX": 1
          },
          {
            "lastModifiedUserId": "ALLOWED-ANONYMOUS",
            "modifiedYm": "202508",
            "get_HI": 1,
            "err_HI": 1,
            "createdYm": "202508",
            "period": "20250819",
            "get_VI": 1,
            "createdTs": 1755615050667,
            "err_VI": 1,
            "modifiedTs": 1755615294018,
            "pop_VI": 1,
            "err_PX": 1,
            "get_BO": 1,
            "hour": "07",
            "get_PX": 1,
            "id": "20250819-09"
          }

        ],
        "day_get_BO": [666, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30],
        "day_lsd_BO": [84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78],
        "day_pop_BO": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 78, 100],
        "day_err_BO": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        "day_get_VI": [6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30],
        "day_lsd_VI": [84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78],
        "day_pop_VI": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 78],
        "day_err_VI": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50],
        "day_get_HI": [6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30],
        "day_lsd_HI": [84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78],
        "day_pop_HI": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 78],
        "day_err_HI": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50],
      },
      {
        "lastModifiedUserId": "ALLOWED-ANONYMOUS",
        "modifiedYm": "202508",
        "get_HI": 1,
        "err_HI": 1,
        "createdYm": "202508",
        "period": "20250819",
        "get_VI": 1,
        "createdTs": 1755615050667,
        "err_VI": 1,
        "modifiedTs": 1755615294018,
        "pop_VI": 1,
        "err_PX": 1,
        "get_BO": 1,
        "get_PX": 1,
        "id": "20250819-09",
        "hourlyData": [
          {
            "modifiedYm": "202508",
            "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
            "cmsPop": 2,
            "createdYm": "202508",
            "period": "20250820",
            "get_VI": 3,
            "createdTs": 1755605483780,
            "err_VI": 1,
            "modifiedTs": 1755605483780,
            "hour": "00",
            "ads_PX": 1,
            "get_PX": 1,
            "id": "20250817-13",
            "lsd_PX": 1
          },
          {
            "lastModifiedUserId": "ALLOWED-ANONYMOUS",
            "modifiedYm": "202508",
            "get_HI": 1,
            "err_HI": 1,
            "createdYm": "202508",
            "period": "20250819",
            "get_VI": 1,
            "createdTs": 1755615050667,
            "err_VI": 1,
            "modifiedTs": 1755615294018,
            "pop_VI": 1,
            "err_PX": 1,
            "get_BO": 1,
            "hour": "01",
            "get_PX": 1,
            "id": "20250819-09"
          },
          {
            "modifiedYm": "202508",
            "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
            "cmsPop": 2,
            "createdYm": "202508",
            "period": "20250820",
            "get_VI": 3,
            "createdTs": 1755605483780,
            "err_VI": 1,
            "modifiedTs": 1755605483780,
            "hour": "02",
            "ads_PX": 1,
            "get_PX": 1,
            "id": "20250817-13",
            "lsd_PX": 1
          },
          {
            "lastModifiedUserId": "ALLOWED-ANONYMOUS",
            "modifiedYm": "202508",
            "get_HI": 1,
            "err_HI": 1,
            "createdYm": "202508",
            "period": "20250819",
            "get_VI": 1,
            "createdTs": 1755615050667,
            "err_VI": 1,
            "modifiedTs": 1755615294018,
            "pop_VI": 1,
            "err_PX": 1,
            "get_BO": 1,
            "hour": "03",
            "get_PX": 1,
            "id": "20250819-09"
          },
          {
            "modifiedYm": "202508",
            "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
            "cmsPop": 2,
            "createdYm": "202508",
            "period": "20250820",
            "get_VI": 3,
            "createdTs": 1755605483780,
            "err_VI": 1,
            "modifiedTs": 1755605483780,
            "hour": "04",
            "ads_PX": 1,
            "get_PX": 1,
            "id": "20250817-13",
            "lsd_PX": 1
          },
          {
            "lastModifiedUserId": "ALLOWED-ANONYMOUS",
            "modifiedYm": "202508",
            "get_HI": 1,
            "err_HI": 1,
            "createdYm": "202508",
            "period": "20250819",
            "get_VI": 1,
            "createdTs": 1755615050667,
            "err_VI": 1,
            "modifiedTs": 1755615294018,
            "pop_VI": 1,
            "err_PX": 1,
            "get_BO": 1,
            "hour": "05",
            "get_PX": 1,
            "id": "20250819-09"
          },
          {
            "modifiedYm": "202508",
            "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
            "cmsPop": 2,
            "createdYm": "202508",
            "period": "20250820",
            "get_VI": 3,
            "createdTs": 1755605483780,
            "err_VI": 1,
            "modifiedTs": 1755605483780,
            "hour": "06",
            "ads_PX": 1,
            "get_PX": 1,
            "id": "20250817-13",
            "lsd_PX": 1
          },
          {
            "lastModifiedUserId": "ALLOWED-ANONYMOUS",
            "modifiedYm": "202508",
            "get_HI": 1,
            "err_HI": 1,
            "createdYm": "202508",
            "period": "20250819",
            "get_VI": 1,
            "createdTs": 1755615050667,
            "err_VI": 1,
            "modifiedTs": 1755615294018,
            "pop_VI": 1,
            "err_PX": 1,
            "get_BO": 1,
            "hour": "07",
            "get_PX": 1,
            "id": "20250819-09"
          }

        ],
        "day_get_PX": [666, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30],
        "day_lsd_PX": [84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78],
        "day_pop_PX": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 78, 100],
        "day_err_PX": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        "day_get_VI": [6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30],
        "day_lsd_VI": [84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 6, 12, 18, 24, 30, 36, 42, 48, 54, 60, 66, 72, 78],
        "day_pop_VI": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 84, 90, 96, 102, 6, 6, 12, 18, 24, 30, 78],
        "day_err_VI": [6, 78, 84, 90, 96, 102, 6, 6, 12, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 50],
      },
    ],
    "items1": [
      {
        "modifiedYm": "202508",
        "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
        "cmsPop": 2,
        "createdYm": "202508",
        "period": "20250820",
        "get_VI": 3,
        "createdTs": 1755605483780,
        "err_VI": 1,
        "modifiedTs": 1755605483780,
        "hour": "13",
        "ads_PX": 1,
        "get_PX": 1,
        "id": "20250817-13",
        "lsd_PX": 1
      },
      {
        "lastModifiedUserId": "ALLOWED-ANONYMOUS",
        "modifiedYm": "202508",
        "get_HI": 1,
        "err_HI": 1,
        "createdYm": "202508",
        "period": "20250819",
        "get_VI": 1,
        "createdTs": 1755615050667,
        "err_VI": 1,
        "modifiedTs": 1755615294018,
        "pop_VI": 1,
        "err_PX": 1,
        "get_BO": 1,
        "hour": "09",
        "get_PX": 1,
        "id": "20250819-09"
      },
      {
        "lastModifiedUserId": "b5275270035511edb286336f3dabca75",
        "modifiedYm": "202508",
        "cmsPop": 4,
        "createdYm": "202508",
        "period": "20250818",
        "get_VI": 6,
        "createdTs": 1755604305601,
        "err_VI": 2,
        "modifiedTs": 1755604748074,
        "hour": "06",
        "ads_PX": 2,
        "get_PX": 2,
        "id": "20250819-06",
        "lsd_PX": 2
      }
    ],
    "stats": {
      "totalGet": 16,
      "totalErr": 6,
      "totalPop": 1,
      "totalLsd": 3,
      "totalCmsPop": 6,
      "totalAds": 3,
      "totalGet_AD": 0,
      "totalErr_AD": 0,
      "totalPop_AD": 0,
      "totalLsd_AD": 0,
      "totalAds_AD": 0,
      "totalGet_BO": 1,
      "totalErr_BO": 0,
      "totalPop_BO": 0,
      "totalLsd_BO": 0,
      "totalAds_BO": 0,
      "totalGet_DD": 0,
      "totalErr_DD": 0,
      "totalPop_DD": 0,
      "totalLsd_DD": 0,
      "totalAds_DD": 0,
      "totalGet_CMS": 0,
      "totalErr_CMS": 0,
      "totalPop_CMS": 0,
      "totalLsd_CMS": 0,
      "totalAds_CMS": 0,
      "totalGet_FR": 0,
      "totalErr_FR": 0,
      "totalPop_FR": 0,
      "totalLsd_FR": 0,
      "totalAds_FR": 0,
      "totalGet_HI": 1,
      "totalErr_HI": 1,
      "totalPop_HI": 0,
      "totalLsd_HI": 0,
      "totalAds_HI": 0,
      "totalGet_LO": 0,
      "totalErr_LO": 0,
      "totalPop_LO": 0,
      "totalLsd_LO": 0,
      "totalAds_LO": 0,
      "totalGet_PX": 4,
      "totalErr_PX": 1,
      "totalPop_PX": 0,
      "totalLsd_PX": 3,
      "totalAds_PX": 3,
      "totalGet_VC": 0,
      "totalErr_VC": 0,
      "totalPop_VC": 0,
      "totalLsd_VC": 0,
      "totalAds_VC": 0,
      "totalGet_VI": 10,
      "totalErr_VI": 4,
      "totalPop_VI": 1,
      "totalLsd_VI": 0,
      "totalAds_VI": 0
    },
    "_apiversion": "1.0.52"
  },
  devicesActivity2: {
    "items": [
      {
        "modifiedYm": "202508",
        "lastModifiedUserId": "831cfe309ea211eea91cb76ae7593786",
        "latestErr_VI": "{\"code\":404,\"body\":\"Err: Device rebooting...\"}",
        "get_AD": 1,
        "lsd_VI": 4,
        "lsd_BO": 2,
        "groupId": "1706761149176",
        "createdYm": "202508",
        "period": "20250804",
        "h05": 1,
        "deviceId": "1706761170635",
        "lsd_AD": 2,
        "get_VI": 2,
        "createdTs": 1754302485513,
        "err_VI": 1,
        "modifiedTs": 1754308730284,
        "pop_VI": 1,
        "get_BO": 1,
        "id": "1706761170635-20250804",
        "get_PX": 3,
        "lsd_PX": 4,
        "hf": 1754302482492,
        "statusByHour": [
          0,
          5,
          3,
          6,
          1,
          1,
          0,
          4,
          1,
          0,
          0,
          0,
          4,
          0,
          4,
          4,
          1,
          0,
          5,
          0,
          4,
          6,
          0,
          0
        ],
        "noOfhrsOnline": 14,
        "deviceCode": "DD-YXVT4A",
        "title": "AZYD3_VENUE_CH_DD_YXVT4A",
        "info": {
          address: '40 Belmont Ave, Brooklyn, NY 11212'
        }
      }
    ],
    "stats": {
      "totalGet": 7,
      "totalErr": 1,
      "totalPop": 1,
      "totalLsd": 12,
      "totalCmsPop": 0,
      "totalGet_AD": 1,
      "totalErr_AD": 0,
      "totalPop_AD": 0,
      "totalLsd_AD": 2,
      "totalGet_BO": 1,
      "totalErr_BO": 0,
      "totalPop_BO": 0,
      "totalLsd_BO": 2,
      "totalGet_DD": 0,
      "totalErr_DD": 0,
      "totalPop_DD": 0,
      "totalLsd_DD": 0,
      "totalGet_CMS": 0,
      "totalErr_CMS": 0,
      "totalPop_CMS": 0,
      "totalLsd_CMS": 0,
      "totalGet_FR": 0,
      "totalErr_FR": 0,
      "totalPop_FR": 0,
      "totalLsd_FR": 0,
      "totalGet_HI": 0,
      "totalErr_HI": 0,
      "totalPop_HI": 0,
      "totalLsd_HI": 0,
      "totalGet_LO": 0,
      "totalErr_LO": 0,
      "totalPop_LO": 0,
      "totalLsd_LO": 0,
      "totalGet_PX": 3,
      "totalErr_PX": 0,
      "totalPop_PX": 0,
      "totalLsd_PX": 4,
      "totalGet_VC": 0,
      "totalErr_VC": 0,
      "totalPop_VC": 0,
      "totalLsd_VC": 0,
      "totalGet_VI": 2,
      "totalErr_VI": 1,
      "totalPop_VI": 1,
      "totalLsd_VI": 4
    },
    "_apiversion": "1.0.52"
  },
  devicesActivity: {
    stats: {
      totalVenues: {
        value: '5.3K',
        title: 'Screens'
      },
      totalGet: {
        value: '200.3K',
        title: 'Hits',
      },
      totalLsd: {
        value: '150K',
        title: 'Leased Ads',
      },
      totalPop: {
        value: '140K',
        title: 'Pop'
      },
      totalErr: {
        value: '20K',
        title: 'Error'
      },
      "totalGet_AD": 1,
      "totalErr_AD": 0,
      "totalPop_AD": 0,
      "totalLsd_AD": 2,
    },
    heartbeat: {
      "labels": [
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16",
        "17",
        "18",
        "19",
        "20",
        "21",
        "22",
        "23"
      ],
      "datasets": [
        {
          "label": "Heartbeat By Hour",
          "data": [
            5,
            2,
            6,
            3,
            5,
            6,
            6,
            4,
            5,
            3,
            0,
            1,
            2,
            3,
            5,
            6,
            3,
            1,
            4,
            3,
            2,
            5,
            6
          ],
          "fill": false,
          "borderColor": "rgba(75,192,192,1)",
          "backgroundColor": "rgba(75,192,192,0.2)",
          "tension": 0.4,
          "pointRadius": 5,
          "pointHoverRadius": 7
        }
      ]
    },
    adChartsExchangesTotal: [
      {
        "chartTitle": "PX",
        "data": {
          "labels": [
            "POP",
            "GET",
            "LEASED",
            "ERROR"
          ],
          "datasets": [
            {
              "data": [
                30,
                60,
                90,
                100
              ],
              "backgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "hoverBackgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderWidth": 0
            }
          ]
        },
        "hasDataMoreThanZero": true
      },
      {
        "chartTitle": "BO",
        "data": {
          "labels": [
            "POP",
            "GET",
            "LEASED",
            "ERROR"
          ],
          "datasets": [
            {
              "data": [
                200,
                100,
                90,
                10
              ],
              "backgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "hoverBackgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderWidth": 0
            }
          ]
        },
        "hasDataMoreThanZero": true
      },
      {
        "chartTitle": "HI",
        "data": {
          "labels": [
            "POP",
            "GET",
            "LEASED",
            "ERROR"
          ],
          "datasets": [
            {
              "data": [
                201,
                100,
                30,
                10
              ],
              "backgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "hoverBackgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderWidth": 0
            }
          ]
        },
        "hasDataMoreThanZero": true
      },
      {
        "chartTitle": "VI",
        "data": {
          "labels": [
            "POP",
            "GET",
            "LEASED",
            "ERROR"
          ],
          "datasets": [
            {
              "data": [
                100,
                90,
                60,
                90
              ],
              "backgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "hoverBackgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderWidth": 0
            }
          ]
        },
        "hasDataMoreThanZero": true
      },
      {
        "chartTitle": "VC",
        "data": {
          "labels": [
            "POP",
            "GET",
            "LEASED",
            "ERROR"
          ],
          "datasets": [
            {
              "data": [
                120,
                90,
                40,
                10
              ],
              "backgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "hoverBackgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderWidth": 0
            }
          ]
        },
        "hasDataMoreThanZero": true
      },
      {
        "chartTitle": "DD",
        "data": {
          "labels": [
            "POP",
            "GET",
            "LEASED",
            "ERROR"
          ],
          "datasets": [
            {
              "data": [
                500,
                90,
                20,
                90
              ],
              "backgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "hoverBackgroundColor": [
                "#9B59B6",
                "#1E90FF",
                "#2ECC71",
                "#E74C3C",
              ],
              "borderWidth": 0
            }
          ]
        },
        "hasDataMoreThanZero": true
      }
    ],
    items: [
      {
        deviceId: '1753834825976',
        deviceCode: 'DD-HB66G5',
        title: 'SNG_PHARMACY_DD_HATYGX',
        info: {
          address: '15115 Westheimer Rd, Houston, TX 77082'
        },
        hf: '1753872025786',
        onlineHrs: 6,
        offlineHrs: 1,
        statusByHour: [
          5,
          2,
          6,
          3,
          5,
          6,
          6,
          4,
          5,
          3,
          0,
          1,
          2,
          3,
          5,
          6,
          3,
          1,
          4,
          3,
          2,
          5,
          6
        ],
      },
      {
        deviceId: '1753834825976',
        deviceCode: 'DD-HHHBBSS',
        title: 'ABCD_TEST',
        info: {
          address: 'New York, NY, USA'
        },
        hf: '1753872025786',
        onlineHrs: 6,
        offlineHrs: 1,
        statusByHour: [
          5,
          2,
          6,
          3,
          5,
          6,
          6,
          4,
          5,
          3,
          0,
          1,
          2,
          3,
          5,
          6,
          3,
          1,
          4,
          3,
          2,
          5,
          6
        ],
      }
    ]
  },
  courses: {
    items: courses
  },
  courseById: {
    1653898475176: {
      title: 'Lorem Ipsum is simply',
      sections: [
        {
          title: 'Section one',
          chapters: [
            {
              title: 'Chapter One',
              videoLink: ''
            }
          ]
        }
      ]
    }
  },
  campaigns: campaigns,
  campaign: campaign,
  contentreview: contentreview,
  adminDevicesActivity: adminDevicesActivity,
  paymentUrl: paymentUrl,
  creatives: creatives,
  deviceActivity: deviceActivity,
  venueFillRate: venueFillRate
}


export const screens = [
  {
    key: 'store1',
    label: 'Store name goes here',
    descr: 'store address, san francisco, 456789 ',
    type: 'checkBox',
    value: 'true',
    distance: '0.2km'
  },
  {
    key: 'store2',
    label: 'Store2 name goes here',
    descr: 'store address, san francisco, 456789 ',
    type: 'checkBox',
    value: '',
    distance: '0.2km'
  },
  {
    key: 'store3',
    label: 'Store3 name goes here',
    descr: 'store address, san francisco, 456789 ',
    type: 'checkBox',
    value: '',
    distance: '0.2km'
  },
  {
    key: 'store4',
    label: 'Store4 name goes here',
    descr: 'store address, san francisco, 456789 ',
    type: 'checkBox',
    value: '',
    distance: '0.2km'
  },
]

export const CampaignData = {
  location: 'Austria',
  radius: 50,
  storeType: 'SuperMarket',
  audienceEthnicity: 'text',
  startDate: '',
  endDate: '',
  screenType: 'Portrait',
  Exclusions: ''
}


export const mockTableData = {
  tableHeaders: ['Graphic Name', 'File Size', 'Other Text'],
  noTableHead: true,
  tableHeadersMap: {},
  items: [
    {
      modifiedYm: '202305',
      lastModifiedUserId: 'b5275270035511edb286336f3dabca75',
      iType: 'DEFAULT',
      deviceCode: '25mb',
      createdYm: '202303',
      info: {
        audience: 'american',
        configtags: [
          'CLOUDLOG_ON',
          '_OPENSSP_VI_PX_MA_HI_BR',
          '_MODE_DI'
        ],
        queuestore: 10,
        installappbuild: '55',
        queuessp: 70,
        queuelocal: 20,
        deviceCode: 'DD-508C73',
        title: 'Azy_One_Plus_8_August_2022_DD_508C73'
      },
      searchable: 'azy_one_plus_8_august_2022_dd_508c73',
      playlists: [
        '1658297406735'
      ],
      deviceId: '1678780451072',
      createdTs: 1678780451097,
      modifiedTs: 1685374165016,
      orgId: '1678780305769',
      id: '1678780451072',
      title: 'Text'
    },
    {
      lastModifiedUserId: 'APIKey',
      modifiedYm: '202305',
      campaigns: [
        'PRODUCT-1681288411468'
      ],
      iType: 'DEFAULT',
      createdYm: '202301',
      deviceCode: '60mb',
      imageAdIds: [
        'displayads1678780305769-1679584104619',
        'displayads1678780305769-1679583768460',
        'displayads1678780305769-1679574992428',
        'displayads1678780305769-1679571984727'
      ],
      latestDeviceFeed: {
        model: 'CPH2471',
        currentTs: 1685427513053,
        osVersion: '12',
        versionCode: 76
      },
      audioAdIds: [
        'audioads1678780305769-1682256638721'
      ],
      state: 'LIVE',
      info: {
        audience: 'american',
        configtags: [
          'CLOUDLOG_ON',
          '_OPENSSP_VI_PX_MA_HI_BR',
          '_MODE_DI'
        ],
        queuestore: 10,
        installappbuild: '55',
        queuessp: 70,
        queuelocal: 20,
        deviceCode: 'DD-790AA9',
        title: 'AzyOppoBlrTest_DD_790AA9'
      },
      searchable: 'oppo blr test',
      playlists: [
        '1658297406735'
      ],
      deviceId: '1674450456678',
      createdTs: 1674450456679,
      modifiedTs: 1685427546819,
      orgId: '1678780305769',
      id: '1674450456678',
      installationId: '45465924',
      title: 'Oppo Blr Test'
    },
    {
      lastModifiedUserId: 'APIKey',
      modifiedYm: '202305',
      campaigns: [
        'PRODUCT-1681288411468'
      ],
      iType: 'DEFAULT',
      createdYm: '202208',
      deviceCode: '1.5mb',
      audioAdId: 'audioads1654769118718-1660149542659',
      imageAdIds: [
        'displayads1678780305769-1679646284438',
        'displayads1678780305769-1679644707818',
        'displayads1678780305769-1679645721684',
        'displayads1678780305769-1679645281803'
      ],
      latestDeviceFeed: {
        model: 'GM1901',
        currentTs: 1684820315008,
        osVersion: '11',
        versionCode: 72
      },
      audioAdIds: [
        'audioads1678780305769-1682256638721'
      ],
      state: 'LIVE',
      info: {
        audience: 'american',
        configtags: [
          'CLOUDLOG_ON',
          '_OPENSSP_VI_PX_MA_HI_BR',
          '_MODE_DI'
        ],
        queuestore: 10,
        installappbuild: '55',
        queuessp: 80,
        queuelocal: 10,
        deviceCode: 'DD-3391FF',
        title: 'Text'
      },
      imageAdId: 'displayads1654769118718-1659348126711',
      searchable: 'azy_test_nokia_phone_16_august_bangalore_dd_3391ff',
      playlists: [
        '1658297406735'
      ],
      deviceId: '1660622638030',
      createdTs: 1660622638030,
      modifiedTs: 1685374165087,
      orgId: '1678780305769',
      id: '1660622638030',
      installationId: '88187620',
      title: 'Text'
    }
  ],
  nextPageState: 2,
  emptyText: 'No venues in this site yet!'
}

export const userTableMockData = {
  tableHeaders: ['User', 'Email', 'Role'],
  noTableHead: true,
  tableHeadersMap: {},
  items: [
    {
      name: 'Sabrish Das',
      email: 'sabrish@azympto.com',
      role: 'Admin'
    },
    {
      name: 'Sabrish Das',
      email: 'sabrish@azympto.com',
      role: 'Admin'
    },
    {
      name: 'Sabrish Das',
      email: 'sabrish@azympto.com',
      role: 'Admin'
    },
  ]
}



// WEBPACK FOOTER //
// ./src/data/MockData.js